// node_modules/.pnpm/@microsoft+dynamicproto-js@1.1.6/node_modules/@microsoft/dynamicproto-js/lib/dist/esm/dynamicproto-js.js
var Constructor = "constructor";
var Prototype = "prototype";
var strFunction = "function";
var DynInstFuncTable = "_dynInstFuncs";
var DynProxyTag = "_isDynProxy";
var DynClassName = "_dynClass";
var DynClassNamePrefix = "_dynCls$";
var DynInstChkTag = "_dynInstChk";
var DynAllowInstChkTag = DynInstChkTag;
var DynProtoDefaultOptions = "_dfOpts";
var UnknownValue = "_unknown_";
var str__Proto = "__proto__";
var DynProtoBaseProto = "_dyn" + str__Proto;
var DynProtoCurrent = "_dynInstProto";
var strUseBaseInst = "useBaseInst";
var strSetInstFuncs = "setInstFuncs";
var Obj = Object;
var _objGetPrototypeOf = Obj["getPrototypeOf"];
var _objGetOwnProps = Obj["getOwnPropertyNames"];
var _dynamicNames = 0;
function _hasOwnProperty(obj, prop) {
  return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
}
function _isObjectOrArrayPrototype(target) {
  return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
function _isObjectArrayOrFunctionPrototype(target) {
  return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
function _getObjProto(target) {
  var newProto;
  if (target) {
    if (_objGetPrototypeOf) {
      return _objGetPrototypeOf(target);
    }
    var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
    newProto = target[DynProtoBaseProto] || curProto;
    if (!_hasOwnProperty(target, DynProtoBaseProto)) {
      delete target[DynProtoCurrent];
      newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
      target[DynProtoCurrent] = curProto;
    }
  }
  return newProto;
}
function _forEachProp(target, func) {
  var props = [];
  if (_objGetOwnProps) {
    props = _objGetOwnProps(target);
  } else {
    for (var name_1 in target) {
      if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
        props.push(name_1);
      }
    }
  }
  if (props && props.length > 0) {
    for (var lp = 0; lp < props.length; lp++) {
      func(props[lp]);
    }
  }
}
function _isDynamicCandidate(target, funcName, skipOwn) {
  return funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName));
}
function _throwTypeError(message) {
  throw new TypeError("DynamicProto: " + message);
}
function _getInstanceFuncs(thisTarget) {
  var instFuncs = {};
  _forEachProp(thisTarget, function(name) {
    if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
      instFuncs[name] = thisTarget[name];
    }
  });
  return instFuncs;
}
function _hasVisited(values, value) {
  for (var lp = values.length - 1; lp >= 0; lp--) {
    if (values[lp] === value) {
      return true;
    }
  }
  return false;
}
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
  function _instFuncProxy(target, funcHost, funcName) {
    var theFunc = funcHost[funcName];
    if (theFunc[DynProxyTag] && useBaseInst) {
      var instFuncTable = target[DynInstFuncTable] || {};
      if (instFuncTable[DynAllowInstChkTag] !== false) {
        theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
      }
    }
    return function() {
      return theFunc.apply(target, arguments);
    };
  }
  var baseFuncs = {};
  _forEachProp(instFuncs, function(name) {
    baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
  });
  var baseProto = _getObjProto(classProto);
  var visited = [];
  while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
    _forEachProp(baseProto, function(name) {
      if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
        baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
      }
    });
    visited.push(baseProto);
    baseProto = _getObjProto(baseProto);
  }
  return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
  var instFunc = null;
  if (target && _hasOwnProperty(proto, DynClassName)) {
    var instFuncTable = target[DynInstFuncTable] || {};
    instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
    if (!instFunc) {
      _throwTypeError("Missing [" + funcName + "] " + strFunction);
    }
    if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
      var canAddInst = !_hasOwnProperty(target, funcName);
      var objProto = _getObjProto(target);
      var visited = [];
      while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
        var protoFunc = objProto[funcName];
        if (protoFunc) {
          canAddInst = protoFunc === currentDynProtoProxy;
          break;
        }
        visited.push(objProto);
        objProto = _getObjProto(objProto);
      }
      try {
        if (canAddInst) {
          target[funcName] = instFunc;
        }
        instFunc[DynInstChkTag] = 1;
      } catch (e) {
        instFuncTable[DynAllowInstChkTag] = false;
      }
    }
  }
  return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
  var protoFunc = proto[funcName];
  if (protoFunc === currentDynProtoProxy) {
    protoFunc = _getObjProto(proto)[funcName];
  }
  if (typeof protoFunc !== strFunction) {
    _throwTypeError("[" + funcName + "] is not a " + strFunction);
  }
  return protoFunc;
}
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
  function _createDynamicPrototype(proto2, funcName) {
    var dynProtoProxy = function() {
      var instFunc = _getInstFunc(this, funcName, proto2, dynProtoProxy) || _getProtoFunc(funcName, proto2, dynProtoProxy);
      return instFunc.apply(this, arguments);
    };
    dynProtoProxy[DynProxyTag] = 1;
    return dynProtoProxy;
  }
  if (!_isObjectOrArrayPrototype(proto)) {
    var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
    var instFuncs_1 = instFuncTable[className] = instFuncTable[className] || {};
    if (instFuncTable[DynAllowInstChkTag] !== false) {
      instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
    }
    _forEachProp(target, function(name) {
      if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
        instFuncs_1[name] = target[name];
        delete target[name];
        if (!_hasOwnProperty(proto, name) || proto[name] && !proto[name][DynProxyTag]) {
          proto[name] = _createDynamicPrototype(proto, name);
        }
      }
    });
  }
}
function _checkPrototype(classProto, thisTarget) {
  if (_objGetPrototypeOf) {
    var visited = [];
    var thisProto = _getObjProto(thisTarget);
    while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
      if (thisProto === classProto) {
        return true;
      }
      visited.push(thisProto);
      thisProto = _getObjProto(thisProto);
    }
    return false;
  }
  return true;
}
function _getObjName(target, unknownValue) {
  if (_hasOwnProperty(target, Prototype)) {
    return target.name || unknownValue || UnknownValue;
  }
  return ((target || {})[Constructor] || {}).name || unknownValue || UnknownValue;
}
function dynamicProto(theClass, target, delegateFunc, options) {
  if (!_hasOwnProperty(theClass, Prototype)) {
    _throwTypeError("theClass is an invalid class definition.");
  }
  var classProto = theClass[Prototype];
  if (!_checkPrototype(classProto, target)) {
    _throwTypeError("[" + _getObjName(theClass) + "] is not in class hierarchy of [" + _getObjName(target) + "]");
  }
  var className = null;
  if (_hasOwnProperty(classProto, DynClassName)) {
    className = classProto[DynClassName];
  } else {
    className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _dynamicNames;
    _dynamicNames++;
    classProto[DynClassName] = className;
  }
  var perfOptions = dynamicProto[DynProtoDefaultOptions];
  var useBaseInst = !!perfOptions[strUseBaseInst];
  if (useBaseInst && options && options[strUseBaseInst] !== void 0) {
    useBaseInst = !!options[strUseBaseInst];
  }
  var instFuncs = _getInstanceFuncs(target);
  var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
  delegateFunc(target, baseFuncs);
  var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
  if (setInstanceFunc && options) {
    setInstanceFunc = !!options[strSetInstFuncs];
  }
  _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
var perfDefaults = {
  setInstFuncs: true,
  useBaseInst: true
};
dynamicProto[DynProtoDefaultOptions] = perfDefaults;

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/__DynamicConstants.js
var _DYN_INITIALIZE = "initialize";
var _DYN_NAME = "name";
var _DYN_GET_NOTIFY_MGR = "getNotifyMgr";
var _DYN_IDENTIFIER = "identifier";
var _DYN_PUSH = "push";
var _DYN_IS_INITIALIZED = "isInitialized";
var _DYN_CONFIG = "config";
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey";
var _DYN_LOGGER = "logger";
var _DYN_LENGTH = "length";
var _DYN_TIME = "time";
var _DYN_PROCESS_NEXT = "processNext";
var _DYN_GET_PROCESS_TEL_CONT0 = "getProcessTelContext";
var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener";
var _DYN_REMOVE_NOTIFICATION_2 = "removeNotificationListener";
var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs";
var _DYN_ON_COMPLETE = "onComplete";
var _DYN_GET_PLUGIN = "getPlugin";
var _DYN_FLUSH = "flush";
var _DYN__EXTENSIONS = "_extensions";
var _DYN_SPLICE = "splice";
var _DYN_TEARDOWN = "teardown";
var _DYN_MESSAGE_ID = "messageId";
var _DYN_MESSAGE = "message";
var _DYN_IS_ASYNC = "isAsync";
var _DYN__DO_TEARDOWN = "_doTeardown";
var _DYN_UPDATE = "update";
var _DYN_GET_NEXT = "getNext";
var _DYN_DIAG_LOG = "diagLog";
var _DYN_SET_NEXT_PLUGIN = "setNextPlugin";
var _DYN_CREATE_NEW = "createNew";
var _DYN_COOKIE_CFG = "cookieCfg";
var _DYN_INDEX_OF = "indexOf";
var _DYN_SUBSTRING = "substring";
var _DYN_USER_AGENT = "userAgent";
var _DYN_SPLIT = "split";
var _DYN_SET_ENABLED = "setEnabled";
var _DYN_SUBSTR = "substr";
var _DYN_NODE_TYPE = "nodeType";
var _DYN_APPLY = "apply";
var _DYN_REPLACE = "replace";
var _DYN_ENABLE_DEBUG_EXCEPTI4 = "enableDebugExceptions";
var _DYN_LOG_INTERNAL_MESSAGE = "logInternalMessage";
var _DYN_TO_LOWER_CASE = "toLowerCase";
var _DYN_CALL = "call";
var _DYN_TYPE = "type";
var _DYN_HANDLER = "handler";
var _DYN_LISTENERS = "listeners";
var _DYN_IS_CHILD_EVT = "isChildEvt";
var _DYN_GET_CTX = "getCtx";
var _DYN_SET_CTX = "setCtx";
var _DYN_COMPLETE = "complete";
var _DYN_TRACE_ID = "traceId";
var _DYN_SPAN_ID = "spanId";
var _DYN_TRACE_FLAGS = "traceFlags";
var _DYN_VERSION = "version";

// node_modules/.pnpm/@microsoft+applicationinsights-shims@2.0.1/node_modules/@microsoft/applicationinsights-shims/dist-esm/Constants.js
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];
var ObjAssign = ObjClass["assign"];
var ObjCreate = ObjClass["create"];
var ObjDefineProperty = ObjClass["defineProperty"];
var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];

// node_modules/.pnpm/@microsoft+applicationinsights-shims@2.0.1/node_modules/@microsoft/applicationinsights-shims/dist-esm/Helpers.js
var _cachedGlobal = null;
function getGlobal(useCached) {
  if (useCached === void 0) {
    useCached = true;
  }
  if (!_cachedGlobal || !useCached) {
    if (typeof globalThis !== strShimUndefined && globalThis) {
      _cachedGlobal = globalThis;
    }
    if (typeof self !== strShimUndefined && self) {
      _cachedGlobal = self;
    }
    if (typeof window !== strShimUndefined && window) {
      _cachedGlobal = window;
    }
    if (typeof global !== strShimUndefined && global) {
      _cachedGlobal = global;
    }
  }
  return _cachedGlobal;
}
function throwTypeError(message) {
  throw new TypeError(message);
}
function objCreateFn(obj) {
  var func = ObjCreate;
  if (func) {
    return func(obj);
  }
  if (obj == null) {
    return {};
  }
  var type = typeof obj;
  if (type !== strShimObject && type !== strShimFunction) {
    throwTypeError("Object prototype may only be an Object:" + obj);
  }
  function tmpFunc() {
  }
  tmpFunc[strShimPrototype] = obj;
  return new tmpFunc();
}

// node_modules/.pnpm/@microsoft+applicationinsights-shims@2.0.1/node_modules/@microsoft/applicationinsights-shims/dist-esm/TsLibShims.js
var SymbolObj = (getGlobal() || {})["Symbol"];
var ReflectObj = (getGlobal() || {})["Reflect"];
var __objAssignFnImpl = function(t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) {
      if (ObjProto[strShimHasOwnProperty].call(s, p)) {
        t[p] = s[p];
      }
    }
  }
  return t;
};
var __assignFn = ObjAssign || __objAssignFnImpl;
var extendStaticsFn = function(d, b) {
  extendStaticsFn = ObjClass["setPrototypeOf"] || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) {
      if (b2[strShimHasOwnProperty](p)) {
        d2[p] = b2[p];
      }
    }
  };
  return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
  if (typeof b !== strShimFunction && b !== null) {
    throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
  }
  extendStaticsFn(d, b);
  function __() {
    this.constructor = d;
  }
  d[strShimPrototype] = b === null ? objCreateFn(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
}
function __spreadArrayFn(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/InternalConstants.js
var STR_EMPTY = "";
var STR_CHANNELS = "channels";
var STR_CORE = "core";
var STR_CREATE_PERF_MGR = "createPerfMgr";
var STR_DISABLED = "disabled";
var STR_EXTENSION_CONFIG = "extensionConfig";
var STR_EXTENSIONS = "extensions";
var STR_PROCESS_TELEMETRY = "processTelemetry";
var STR_PRIORITY = "priority";
var STR_EVENTS_SENT = "eventsSent";
var STR_EVENTS_DISCARDED = "eventsDiscarded";
var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
var STR_PERF_EVENT = "perfEvent";
var STR_ERROR_TO_CONSOLE = "errorToConsole";
var STR_WARN_TO_CONSOLE = "warnToConsole";
var STR_GET_PERF_MGR = "getPerfMgr";

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/HelperFuncs.js
var strToISOString = "toISOString";
var cStrEndsWith = "endsWith";
var cStrStartsWith = "startsWith";
var strIndexOf = "indexOf";
var strMap = "map";
var strReduce = "reduce";
var cStrTrim = "trim";
var strToString = "toString";
var str__Proto2 = "__proto__";
var strConstructor = "constructor";
var _objDefineProperty = ObjDefineProperty;
var _objFreeze = ObjClass.freeze;
var _objSeal = ObjClass.seal;
var _objKeys = ObjClass.keys;
var StringProto = String[strShimPrototype];
var _strTrim = StringProto[cStrTrim];
var _strEndsWith = StringProto[cStrEndsWith];
var _strStartsWith = StringProto[cStrStartsWith];
var DateProto = Date[strShimPrototype];
var _dataToISOString = DateProto[strToISOString];
var _isArray = Array.isArray;
var _objToString = ObjProto[strToString];
var _fnToString = ObjHasOwnProperty[strToString];
var _objFunctionString = _fnToString[_DYN_CALL](ObjClass);
var rCamelCase = /-([a-z])/g;
var rNormalizeInvalid = /([^\w\d_$])/g;
var rLeadingNumeric = /^(\d+[\w\d_$])/;
var _objGetPrototypeOf2 = Object["getPrototypeOf"];
function _getObjProto2(target) {
  if (target) {
    if (_objGetPrototypeOf2) {
      return _objGetPrototypeOf2(target);
    }
    var newProto = target[str__Proto2] || target[strShimPrototype] || target[strConstructor];
    if (newProto) {
      return newProto;
    }
  }
  return null;
}
function isTypeof(value, theType) {
  return typeof value === theType;
}
function isUndefined(value) {
  return value === void 0 || typeof value === strShimUndefined;
}
function isNullOrUndefined(value) {
  return value === null || isUndefined(value);
}
function isNotNullOrUndefined(value) {
  return !isNullOrUndefined(value);
}
function hasOwnProperty(obj, prop) {
  return !!(obj && ObjHasOwnProperty[_DYN_CALL](obj, prop));
}
function isObject(value) {
  return !!(value && typeof value === strShimObject);
}
function isFunction(value) {
  return !!(value && typeof value === strShimFunction);
}
function normalizeJsName(name) {
  var value = name;
  if (value && isString(value)) {
    value = value[_DYN_REPLACE](rCamelCase, function(_all, letter) {
      return letter.toUpperCase();
    });
    value = value[_DYN_REPLACE](rNormalizeInvalid, "_");
    value = value[_DYN_REPLACE](rLeadingNumeric, function(_all, match) {
      return "_" + match;
    });
  }
  return value;
}
function objForEachKey(target, callbackfn) {
  if (target) {
    for (var prop in target) {
      if (ObjHasOwnProperty[_DYN_CALL](target, prop)) {
        callbackfn[_DYN_CALL](target, prop, target[prop]);
      }
    }
  }
}
function strEndsWith(value, search) {
  var result = false;
  if (value && search && !(result = value === search)) {
    result = _strEndsWith ? value[cStrEndsWith](search) : _strEndsWithPoly(value, search);
  }
  return result;
}
function _strEndsWithPoly(value, search) {
  var result = false;
  var searchLen = search ? search[_DYN_LENGTH] : 0;
  var valLen = value ? value[_DYN_LENGTH] : 0;
  if (searchLen && valLen && valLen >= searchLen && !(result = value === search)) {
    var pos = valLen - 1;
    for (var lp = searchLen - 1; lp >= 0; lp--) {
      if (value[pos] != search[lp]) {
        return false;
      }
      pos--;
    }
    result = true;
  }
  return result;
}
function strContains(value, search) {
  if (value && search) {
    return value[_DYN_INDEX_OF](search) !== -1;
  }
  return false;
}
function isDate(obj) {
  return !!(obj && _objToString[_DYN_CALL](obj) === "[object Date]");
}
var isArray = _isArray || _isArrayPoly;
function _isArrayPoly(obj) {
  return !!(obj && _objToString[_DYN_CALL](obj) === "[object Array]");
}
function isError(obj) {
  return !!(obj && _objToString[_DYN_CALL](obj) === "[object Error]");
}
function isString(value) {
  return typeof value === "string";
}
function isNumber(value) {
  return typeof value === "number";
}
function isBoolean(value) {
  return typeof value === "boolean";
}
function isPlainObject(value) {
  var result = false;
  if (value && typeof value === "object") {
    var proto = _objGetPrototypeOf2 ? _objGetPrototypeOf2(value) : _getObjProto2(value);
    if (!proto) {
      result = true;
    } else {
      if (proto[strConstructor] && ObjHasOwnProperty[_DYN_CALL](proto, strConstructor)) {
        proto = proto[strConstructor];
      }
      result = typeof proto === strShimFunction && _fnToString[_DYN_CALL](proto) === _objFunctionString;
    }
  }
  return result;
}
function toISOString(date) {
  if (date) {
    return _dataToISOString ? date[strToISOString]() : _toISOStringPoly(date);
  }
}
function _toISOStringPoly(date) {
  if (date && date.getUTCFullYear) {
    var pad = function(num) {
      var r = String(num);
      if (r[_DYN_LENGTH] === 1) {
        r = "0" + r;
      }
      return r;
    };
    return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + "T" + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds()) + "." + String((date.getUTCMilliseconds() / 1e3).toFixed(3)).slice(2, 5) + "Z";
  }
}
function arrForEach(arr, callbackfn, thisArg) {
  var len = arr[_DYN_LENGTH];
  try {
    for (var idx = 0; idx < len; idx++) {
      if (idx in arr) {
        if (callbackfn[_DYN_CALL](thisArg || arr, arr[idx], idx, arr) === -1) {
          break;
        }
      }
    }
  } catch (e) {
  }
}
function arrIndexOf(arr, searchElement, fromIndex) {
  if (arr) {
    if (arr[strIndexOf]) {
      return arr[strIndexOf](searchElement, fromIndex);
    }
    var len = arr[_DYN_LENGTH];
    var from = fromIndex || 0;
    try {
      for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
        if (lp in arr && arr[lp] === searchElement) {
          return lp;
        }
      }
    } catch (e) {
    }
  }
  return -1;
}
function arrMap(arr, callbackfn, thisArg) {
  var results;
  if (arr) {
    if (arr[strMap]) {
      return arr[strMap](callbackfn, thisArg);
    }
    var len = arr[_DYN_LENGTH];
    var _this = thisArg || arr;
    results = new Array(len);
    try {
      for (var lp = 0; lp < len; lp++) {
        if (lp in arr) {
          results[lp] = callbackfn[_DYN_CALL](_this, arr[lp], arr);
        }
      }
    } catch (e) {
    }
  }
  return results;
}
function arrReduce(arr, callbackfn, initialValue) {
  var value;
  if (arr) {
    if (arr[strReduce]) {
      return arr[strReduce](callbackfn, initialValue);
    }
    var len = arr[_DYN_LENGTH];
    var lp = 0;
    if (arguments[_DYN_LENGTH] >= 3) {
      value = arguments[2];
    } else {
      while (lp < len && !(lp in arr)) {
        lp++;
      }
      value = arr[lp++];
    }
    while (lp < len) {
      if (lp in arr) {
        value = callbackfn(value, arr[lp], lp, arr);
      }
      lp++;
    }
  }
  return value;
}
function strTrim(str) {
  if (str) {
    str = _strTrim && str[cStrTrim] ? str[cStrTrim]() : str[_DYN_REPLACE] ? str[_DYN_REPLACE](/^\s+|\s+$/g, STR_EMPTY) : str;
  }
  return str;
}
var _objKeysHasDontEnumBug = !{ toString: null }.propertyIsEnumerable("toString");
var _objKeysDontEnums = [
  "toString",
  "toLocaleString",
  "valueOf",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "constructor"
];
function objKeys(obj) {
  var objType = typeof obj;
  if (objType !== strShimFunction && (objType !== strShimObject || obj === null)) {
    throwTypeError("objKeys called on non-object");
  }
  if (!_objKeysHasDontEnumBug && _objKeys) {
    return _objKeys(obj);
  }
  var result = [];
  for (var prop in obj) {
    if (obj && ObjHasOwnProperty[_DYN_CALL](obj, prop)) {
      result[_DYN_PUSH](prop);
    }
  }
  if (_objKeysHasDontEnumBug) {
    var dontEnumsLength = _objKeysDontEnums[_DYN_LENGTH];
    for (var lp = 0; lp < dontEnumsLength; lp++) {
      if (obj && ObjHasOwnProperty[_DYN_CALL](obj, _objKeysDontEnums[lp])) {
        result[_DYN_PUSH](_objKeysDontEnums[lp]);
      }
    }
  }
  return result;
}
function objDefineAccessors(target, prop, getProp, setProp) {
  if (_objDefineProperty) {
    try {
      var descriptor = {
        enumerable: true,
        configurable: true
      };
      if (getProp) {
        descriptor.get = getProp;
      }
      if (setProp) {
        descriptor.set = setProp;
      }
      _objDefineProperty(target, prop, descriptor);
      return true;
    } catch (e) {
    }
  }
  return false;
}
function _doNothing(value) {
  return value;
}
function deepFreeze(obj) {
  if (_objFreeze) {
    objForEachKey(obj, function(name, value) {
      if (isArray(value) || isObject(value)) {
        _objFreeze(value);
      }
    });
  }
  return objFreeze(obj);
}
var objFreeze = _objFreeze || _doNothing;
function dateNow() {
  var dt = Date;
  return dt.now ? dt.now() : new dt().getTime();
}
function getExceptionName(object) {
  if (isError(object)) {
    return object[_DYN_NAME];
  }
  return STR_EMPTY;
}
function setValue(target, field, value, valChk, srcChk) {
  var theValue = value;
  if (target) {
    theValue = target[field];
    if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
      theValue = value;
      target[field] = theValue;
    }
  }
  return theValue;
}
function getSetValue(target, field, defValue) {
  var theValue;
  if (target) {
    theValue = target[field];
    if (!theValue && isNullOrUndefined(theValue)) {
      theValue = !isUndefined(defValue) ? defValue : {};
      target[field] = theValue;
    }
  } else {
    theValue = !isUndefined(defValue) ? defValue : {};
  }
  return theValue;
}
function getCfgValue(theValue, defaultValue) {
  return !isNullOrUndefined(theValue) ? theValue : defaultValue;
}
function isTruthy(value) {
  return !!value;
}
function throwError(message) {
  throw new Error(message);
}
function _createProxyFunction(source, funcName) {
  var srcFunc = null;
  var src = null;
  if (isFunction(source)) {
    srcFunc = source;
  } else {
    src = source;
  }
  return function() {
    var originalArguments = arguments;
    if (srcFunc) {
      src = srcFunc();
    }
    if (src) {
      return src[funcName][_DYN_APPLY](src, originalArguments);
    }
  };
}
function proxyAssign(target, source, chkSet) {
  if (target && source && isObject(target) && isObject(source)) {
    var _loop_1 = function(field2) {
      if (isString(field2)) {
        var value = source[field2];
        if (isFunction(value)) {
          if (!chkSet || chkSet(field2, true, source, target)) {
            target[field2] = _createProxyFunction(source, field2);
          }
        } else if (!chkSet || chkSet(field2, false, source, target)) {
          if (hasOwnProperty(target, field2)) {
            delete target[field2];
          }
          if (!objDefineAccessors(target, field2, function() {
            return source[field2];
          }, function(theValue) {
            source[field2] = theValue;
          })) {
            target[field2] = value;
          }
        }
      }
    };
    for (var field in source) {
      _loop_1(field);
    }
  }
  return target;
}
function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
  if (target && name && source) {
    if (overwriteTarget !== false || isUndefined(target[name])) {
      target[name] = _createProxyFunction(source, theFunc);
    }
  }
}
function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
  if (target && source && isObject(target) && isArray(functionsToProxy)) {
    arrForEach(functionsToProxy, function(theFuncName) {
      if (isString(theFuncName)) {
        proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
      }
    });
  }
  return target;
}
function createClassFromInterface(defaults) {
  return function() {
    function class_1() {
      var _this_1 = this;
      if (defaults) {
        objForEachKey(defaults, function(field, value) {
          _this_1[field] = value;
        });
      }
    }
    return class_1;
  }();
}
function optimizeObject(theObject) {
  if (theObject && ObjAssign) {
    theObject = ObjClass(ObjAssign({}, theObject));
  }
  return theObject;
}
function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
  var theArgs = arguments;
  var extended = theArgs[0] || {};
  var argLen = theArgs[_DYN_LENGTH];
  var deep = false;
  var idx = 1;
  if (argLen > 0 && isBoolean(extended)) {
    deep = extended;
    extended = theArgs[idx] || {};
    idx++;
  }
  if (!isObject(extended)) {
    extended = {};
  }
  for (; idx < argLen; idx++) {
    var arg = theArgs[idx];
    var isArgArray = isArray(arg);
    var isArgObj = isObject(arg);
    for (var prop in arg) {
      var propOk = isArgArray && prop in arg || isArgObj && ObjHasOwnProperty[_DYN_CALL](arg, prop);
      if (!propOk) {
        continue;
      }
      var newValue = arg[prop];
      var isNewArray = void 0;
      if (deep && newValue && ((isNewArray = isArray(newValue)) || isPlainObject(newValue))) {
        var clone = extended[prop];
        if (isNewArray) {
          if (!isArray(clone)) {
            clone = [];
          }
        } else if (!isPlainObject(clone)) {
          clone = {};
        }
        newValue = objExtend(deep, clone, newValue);
      }
      if (newValue !== void 0) {
        extended[prop] = newValue;
      }
    }
  }
  return extended;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/PerfManager.js
var strExecutionContextKey = "ctx";
var strParentContextKey = "ParentContextKey";
var strChildrenContextKey = "ChildrenContextKey";
var _defaultPerfManager = null;
var PerfEvent = function() {
  function PerfEvent2(name, payloadDetails, isAsync) {
    var _self = this;
    var accessorDefined = false;
    _self.start = dateNow();
    _self[_DYN_NAME] = name;
    _self[_DYN_IS_ASYNC] = isAsync;
    _self[_DYN_IS_CHILD_EVT] = function() {
      return false;
    };
    if (isFunction(payloadDetails)) {
      var theDetails_1;
      accessorDefined = objDefineAccessors(_self, "payload", function() {
        if (!theDetails_1 && isFunction(payloadDetails)) {
          theDetails_1 = payloadDetails();
          payloadDetails = null;
        }
        return theDetails_1;
      });
    }
    _self[_DYN_GET_CTX] = function(key) {
      if (key) {
        if (key === PerfEvent2[strParentContextKey] || key === PerfEvent2[strChildrenContextKey]) {
          return _self[key];
        }
        return (_self[strExecutionContextKey] || {})[key];
      }
      return null;
    };
    _self[_DYN_SET_CTX] = function(key, value) {
      if (key) {
        if (key === PerfEvent2[strParentContextKey]) {
          if (!_self[key]) {
            _self[_DYN_IS_CHILD_EVT] = function() {
              return true;
            };
          }
          _self[key] = value;
        } else if (key === PerfEvent2[strChildrenContextKey]) {
          _self[key] = value;
        } else {
          var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
          ctx[key] = value;
        }
      }
    };
    _self[_DYN_COMPLETE] = function() {
      var childTime = 0;
      var childEvts = _self[_DYN_GET_CTX](PerfEvent2[strChildrenContextKey]);
      if (isArray(childEvts)) {
        for (var lp = 0; lp < childEvts[_DYN_LENGTH]; lp++) {
          var childEvt = childEvts[lp];
          if (childEvt) {
            childTime += childEvt[_DYN_TIME];
          }
        }
      }
      _self[_DYN_TIME] = dateNow() - _self.start;
      _self.exTime = _self[_DYN_TIME] - childTime;
      _self[_DYN_COMPLETE] = function() {
      };
      if (!accessorDefined && isFunction(payloadDetails)) {
        _self.payload = payloadDetails();
      }
    };
  }
  PerfEvent2.ParentContextKey = "parent";
  PerfEvent2.ChildrenContextKey = "childEvts";
  return PerfEvent2;
}();
var PerfManager = function() {
  function PerfManager2(manager) {
    this.ctx = {};
    dynamicProto(PerfManager2, this, function(_self) {
      _self.create = function(src, payloadDetails, isAsync) {
        return new PerfEvent(src, payloadDetails, isAsync);
      };
      _self.fire = function(perfEvent) {
        if (perfEvent) {
          perfEvent[_DYN_COMPLETE]();
          if (manager && isFunction(manager[STR_PERF_EVENT])) {
            manager[STR_PERF_EVENT](perfEvent);
          }
        }
      };
      _self[_DYN_SET_CTX] = function(key, value) {
        if (key) {
          var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
          ctx[key] = value;
        }
      };
      _self[_DYN_GET_CTX] = function(key) {
        return (_self[strExecutionContextKey] || {})[key];
      };
    });
  }
  PerfManager2.__ieDyn = 1;
  return PerfManager2;
}();
var doPerfActiveKey = "CoreUtils.doPerf";
function doPerf(mgrSource, getSource, func, details, isAsync) {
  if (mgrSource) {
    var perfMgr = mgrSource;
    if (perfMgr[STR_GET_PERF_MGR]) {
      perfMgr = perfMgr[STR_GET_PERF_MGR]();
    }
    if (perfMgr) {
      var perfEvt = void 0;
      var currentActive = perfMgr[_DYN_GET_CTX](doPerfActiveKey);
      try {
        perfEvt = perfMgr.create(getSource(), details, isAsync);
        if (perfEvt) {
          if (currentActive && perfEvt[_DYN_SET_CTX]) {
            perfEvt[_DYN_SET_CTX](PerfEvent[strParentContextKey], currentActive);
            if (currentActive[_DYN_GET_CTX] && currentActive[_DYN_SET_CTX]) {
              var children = currentActive[_DYN_GET_CTX](PerfEvent[strChildrenContextKey]);
              if (!children) {
                children = [];
                currentActive[_DYN_SET_CTX](PerfEvent[strChildrenContextKey], children);
              }
              children[_DYN_PUSH](perfEvt);
            }
          }
          perfMgr[_DYN_SET_CTX](doPerfActiveKey, perfEvt);
          return func(perfEvt);
        }
      } catch (ex) {
        if (perfEvt && perfEvt[_DYN_SET_CTX]) {
          perfEvt[_DYN_SET_CTX]("exception", ex);
        }
      } finally {
        if (perfEvt) {
          perfMgr.fire(perfEvt);
        }
        perfMgr[_DYN_SET_CTX](doPerfActiveKey, currentActive);
      }
    }
  }
  return func();
}
function getGblPerfMgr() {
  return _defaultPerfManager;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/EnvUtils.js
var strWindow = "window";
var strDocument = "document";
var strDocumentMode = "documentMode";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strConsole = "console";
var strPerformance = "performance";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var strXMLHttpRequest = "XMLHttpRequest";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
var _useXDomainRequest = null;
var _beaconsSupported = null;
function _hasProperty(theClass, property) {
  var supported = false;
  if (theClass) {
    try {
      supported = property in theClass;
      if (!supported) {
        var proto = theClass[strShimPrototype];
        if (proto) {
          supported = property in proto;
        }
      }
    } catch (e) {
    }
    if (!supported) {
      try {
        var tmp = new theClass();
        supported = !isUndefined(tmp[property]);
      } catch (e) {
      }
    }
  }
  return supported;
}
function getGlobalInst(name) {
  var gbl = getGlobal();
  if (gbl && gbl[name]) {
    return gbl[name];
  }
  if (name === strWindow && hasWindow()) {
    return window;
  }
  return null;
}
function hasWindow() {
  return Boolean(typeof window === strShimObject && window);
}
function getWindow() {
  if (hasWindow()) {
    return window;
  }
  return getGlobalInst(strWindow);
}
function hasDocument() {
  return Boolean(typeof document === strShimObject && document);
}
function getDocument() {
  if (hasDocument()) {
    return document;
  }
  return getGlobalInst(strDocument);
}
function hasNavigator() {
  return Boolean(typeof navigator === strShimObject && navigator);
}
function getNavigator() {
  if (hasNavigator()) {
    return navigator;
  }
  return getGlobalInst(strNavigator);
}
function hasHistory() {
  return Boolean(typeof history === strShimObject && history);
}
function getHistory() {
  if (hasHistory()) {
    return history;
  }
  return getGlobalInst(strHistory);
}
function getLocation(checkForMock) {
  if (checkForMock && _enableMocks) {
    var mockLocation = getGlobalInst("__mockLocation");
    if (mockLocation) {
      return mockLocation;
    }
  }
  if (typeof location === strShimObject && location) {
    return location;
  }
  return getGlobalInst(strLocation);
}
function getConsole() {
  if (typeof console !== strShimUndefined) {
    return console;
  }
  return getGlobalInst(strConsole);
}
function getPerformance() {
  return getGlobalInst(strPerformance);
}
function hasJSON() {
  return Boolean(typeof JSON === strShimObject && JSON || getGlobalInst(strJSON) !== null);
}
function getJSON() {
  if (hasJSON()) {
    return JSON || getGlobalInst(strJSON);
  }
  return null;
}
function getCrypto() {
  return getGlobalInst(strCrypto);
}
function getMsCrypto() {
  return getGlobalInst(strMsCrypto);
}
function isReactNative() {
  var nav = getNavigator();
  if (nav && nav.product) {
    return nav.product === strReactNative;
  }
  return false;
}
function isIE() {
  var nav = getNavigator();
  if (nav && (nav[_DYN_USER_AGENT] !== _navUserAgentCheck || _isTrident === null)) {
    _navUserAgentCheck = nav[_DYN_USER_AGENT];
    var userAgent = (_navUserAgentCheck || STR_EMPTY)[_DYN_TO_LOWER_CASE]();
    _isTrident = strContains(userAgent, strMsie) || strContains(userAgent, strTrident);
  }
  return _isTrident;
}
function getIEVersion(userAgentStr) {
  if (userAgentStr === void 0) {
    userAgentStr = null;
  }
  if (!userAgentStr) {
    var navigator_1 = getNavigator() || {};
    userAgentStr = navigator_1 ? (navigator_1[_DYN_USER_AGENT] || STR_EMPTY)[_DYN_TO_LOWER_CASE]() : STR_EMPTY;
  }
  var ua = (userAgentStr || STR_EMPTY)[_DYN_TO_LOWER_CASE]();
  if (strContains(ua, strMsie)) {
    var doc = getDocument() || {};
    return Math.max(parseInt(ua[_DYN_SPLIT](strMsie)[1]), doc[strDocumentMode] || 0);
  } else if (strContains(ua, strTrident)) {
    var tridentVer = parseInt(ua[_DYN_SPLIT](strTrident)[1]);
    if (tridentVer) {
      return tridentVer + 4;
    }
  }
  return null;
}
function dumpObj(object) {
  var objectTypeDump = Object[strShimPrototype].toString[_DYN_CALL](object);
  var propertyValueDump = STR_EMPTY;
  if (objectTypeDump === "[object Error]") {
    propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object[_DYN_NAME] + "'";
  } else if (hasJSON()) {
    propertyValueDump = getJSON().stringify(object);
  }
  return objectTypeDump + propertyValueDump;
}
function isBeaconsSupported() {
  if (_beaconsSupported === null) {
    _beaconsSupported = hasNavigator() && Boolean(getNavigator().sendBeacon);
  }
  return _beaconsSupported;
}
function isFetchSupported(withKeepAlive) {
  var isSupported = false;
  try {
    isSupported = !!getGlobalInst("fetch");
    var request = getGlobalInst("Request");
    if (isSupported && withKeepAlive && request) {
      isSupported = _hasProperty(request, "keepalive");
    }
  } catch (e) {
  }
  return isSupported;
}
function useXDomainRequest() {
  if (_useXDomainRequest === null) {
    _useXDomainRequest = typeof XDomainRequest !== strShimUndefined;
    if (_useXDomainRequest && isXhrSupported()) {
      _useXDomainRequest = _useXDomainRequest && !_hasProperty(getGlobalInst(strXMLHttpRequest), "withCredentials");
    }
  }
  return _useXDomainRequest;
}
function isXhrSupported() {
  var isSupported = false;
  try {
    var xmlHttpRequest = getGlobalInst(strXMLHttpRequest);
    isSupported = !!xmlHttpRequest;
  } catch (e) {
  }
  return isSupported;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/DbgExtensionUtils.js
var listenerFuncs = ["eventsSent", "eventsDiscarded", "eventsSendRequest", "perfEvent"];
var _aiNamespace = null;
var _debugListener;
function _listenerProxyFunc(name, config) {
  return function() {
    var args = arguments;
    var dbgExt = getDebugExt(config);
    if (dbgExt) {
      var listener = dbgExt.listener;
      if (listener && listener[name]) {
        listener[name][_DYN_APPLY](listener, args);
      }
    }
  };
}
function _getExtensionNamespace() {
  var target = getGlobalInst("Microsoft");
  if (target) {
    _aiNamespace = target["ApplicationInsights"];
  }
  return _aiNamespace;
}
function getDebugExt(config) {
  var ns = _aiNamespace;
  if (!ns && config.disableDbgExt !== true) {
    ns = _aiNamespace || _getExtensionNamespace();
  }
  return ns ? ns["ChromeDbgExt"] : null;
}
function getDebugListener(config) {
  if (!_debugListener) {
    _debugListener = {};
    for (var lp = 0; lp < listenerFuncs[_DYN_LENGTH]; lp++) {
      _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
    }
  }
  return _debugListener;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/DiagnosticLogger.js
var AiNonUserActionablePrefix = "AI (Internal): ";
var AiUserActionablePrefix = "AI: ";
var AIInternalMessagePrefix = "AITR_";
function _sanitizeDiagnosticText(text) {
  if (text) {
    return '"' + text[_DYN_REPLACE](/\"/g, STR_EMPTY) + '"';
  }
  return STR_EMPTY;
}
function _logToConsole(func, message) {
  var theConsole = getConsole();
  if (!!theConsole) {
    var logFunc = "log";
    if (theConsole[func]) {
      logFunc = func;
    }
    if (isFunction(theConsole[logFunc])) {
      theConsole[logFunc](message);
    }
  }
}
var _InternalLogMessage = function() {
  function _InternalLogMessage2(msgId, msg, isUserAct, properties) {
    if (isUserAct === void 0) {
      isUserAct = false;
    }
    var _self = this;
    _self[_DYN_MESSAGE_ID] = msgId;
    _self[_DYN_MESSAGE] = (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) + msgId;
    var strProps = STR_EMPTY;
    if (hasJSON()) {
      strProps = getJSON().stringify(properties);
    }
    var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : STR_EMPTY) + (properties ? " props:" + _sanitizeDiagnosticText(strProps) : STR_EMPTY);
    _self[_DYN_MESSAGE] += diagnosticText;
  }
  _InternalLogMessage2.dataType = "MessageData";
  return _InternalLogMessage2;
}();
function safeGetLogger(core, config) {
  return (core || {})[_DYN_LOGGER] || new DiagnosticLogger(config);
}
var DiagnosticLogger = function() {
  function DiagnosticLogger2(config) {
    this.identifier = "DiagnosticLogger";
    this.queue = [];
    var _messageCount = 0;
    var _messageLogged = {};
    var _loggingLevelConsole;
    var _loggingLevelTelemetry;
    var _maxInternalMessageLimit;
    var _enableDebugExceptions;
    dynamicProto(DiagnosticLogger2, this, function(_self) {
      _setDefaultsFromConfig(config || {});
      _self.consoleLoggingLevel = function() {
        return _loggingLevelConsole;
      };
      _self.telemetryLoggingLevel = function() {
        return _loggingLevelTelemetry;
      };
      _self.maxInternalMessageLimit = function() {
        return _maxInternalMessageLimit;
      };
      _self[_DYN_ENABLE_DEBUG_EXCEPTI4] = function() {
        return _enableDebugExceptions;
      };
      _self.throwInternal = function(severity, msgId, msg, properties, isUserAct) {
        if (isUserAct === void 0) {
          isUserAct = false;
        }
        var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
        if (_enableDebugExceptions) {
          throw dumpObj(message);
        } else {
          var logFunc = severity === 1 ? STR_ERROR_TO_CONSOLE : STR_WARN_TO_CONSOLE;
          if (!isUndefined(message[_DYN_MESSAGE])) {
            if (isUserAct) {
              var messageKey = +message[_DYN_MESSAGE_ID];
              if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                _self[logFunc](message[_DYN_MESSAGE]);
                _messageLogged[messageKey] = true;
              }
            } else {
              if (_loggingLevelConsole >= severity) {
                _self[logFunc](message[_DYN_MESSAGE]);
              }
            }
            _logInternalMessage2(severity, message);
          } else {
            _debugExtMsg("throw" + (severity === 1 ? "Critical" : "Warning"), message);
          }
        }
      };
      _self[STR_WARN_TO_CONSOLE] = function(message) {
        _logToConsole("warn", message);
        _debugExtMsg("warning", message);
      };
      _self[STR_ERROR_TO_CONSOLE] = function(message) {
        _logToConsole("error", message);
        _debugExtMsg("error", message);
      };
      _self.resetInternalMessageCount = function() {
        _messageCount = 0;
        _messageLogged = {};
      };
      _self[_DYN_LOG_INTERNAL_MESSAGE] = _logInternalMessage2;
      function _logInternalMessage2(severity, message) {
        if (_areInternalMessagesThrottled()) {
          return;
        }
        var logMessage = true;
        var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID];
        if (_messageLogged[messageKey]) {
          logMessage = false;
        } else {
          _messageLogged[messageKey] = true;
        }
        if (logMessage) {
          if (severity <= _loggingLevelTelemetry) {
            _self.queue[_DYN_PUSH](message);
            _messageCount++;
            _debugExtMsg(severity === 1 ? "error" : "warn", message);
          }
          if (_messageCount === _maxInternalMessageLimit) {
            var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
            var throttleMessage = new _InternalLogMessage(23, throttleLimitMessage, false);
            _self.queue[_DYN_PUSH](throttleMessage);
            if (severity === 1) {
              _self[STR_ERROR_TO_CONSOLE](throttleLimitMessage);
            } else {
              _self[STR_WARN_TO_CONSOLE](throttleLimitMessage);
            }
          }
        }
      }
      function _setDefaultsFromConfig(config2) {
        _loggingLevelConsole = getCfgValue(config2.loggingLevelConsole, 0);
        _loggingLevelTelemetry = getCfgValue(config2.loggingLevelTelemetry, 1);
        _maxInternalMessageLimit = getCfgValue(config2.maxMessageLimit, 25);
        _enableDebugExceptions = getCfgValue(config2[_DYN_ENABLE_DEBUG_EXCEPTI4], false);
      }
      function _areInternalMessagesThrottled() {
        return _messageCount >= _maxInternalMessageLimit;
      }
      function _debugExtMsg(name, data) {
        var dbgExt = getDebugExt(config || {});
        if (dbgExt && dbgExt[_DYN_DIAG_LOG]) {
          dbgExt[_DYN_DIAG_LOG](name, data);
        }
      }
    });
  }
  DiagnosticLogger2.__ieDyn = 1;
  return DiagnosticLogger2;
}();
function _getLogger(logger) {
  return logger || new DiagnosticLogger();
}
function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
  if (isUserAct === void 0) {
    isUserAct = false;
  }
  _getLogger(logger).throwInternal(severity, msgId, msg, properties, isUserAct);
}
function _warnToConsole(logger, message) {
  _getLogger(logger)[STR_WARN_TO_CONSOLE](message);
}
function _logInternalMessage(logger, severity, message) {
  _getLogger(logger)[_DYN_LOG_INTERNAL_MESSAGE](severity, message);
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/CookieMgr.js
var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strEnabled = "enabled";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc = getDocument();
var _cookieCache = {};
var _globalCookieConfig = {};
function _gblCookieMgr(config, logger) {
  var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
  if (!inst) {
    inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
    _globalCookieConfig[strConfigCookieMgr] = inst;
  }
  return inst;
}
function _isMgrEnabled(cookieMgr) {
  if (cookieMgr) {
    return cookieMgr.isEnabled();
  }
  return true;
}
function _createCookieMgrConfig(rootConfig) {
  var cookieMgrCfg = rootConfig[_DYN_COOKIE_CFG] = rootConfig[_DYN_COOKIE_CFG] || {};
  setValue(cookieMgrCfg, "domain", rootConfig.cookieDomain, isNotNullOrUndefined, isNullOrUndefined);
  setValue(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, isNullOrUndefined);
  if (isNullOrUndefined(cookieMgrCfg[strEnabled])) {
    var cookieEnabled = void 0;
    if (!isUndefined(rootConfig[strIsCookieUseDisabled])) {
      cookieEnabled = !rootConfig[strIsCookieUseDisabled];
    }
    if (!isUndefined(rootConfig[strDisableCookiesUsage])) {
      cookieEnabled = !rootConfig[strDisableCookiesUsage];
    }
    cookieMgrCfg[strEnabled] = cookieEnabled;
  }
  return cookieMgrCfg;
}
function _isIgnoredCookie(cookieMgrCfg, name) {
  if (name && cookieMgrCfg && isArray(cookieMgrCfg.ignoreCookies)) {
    return cookieMgrCfg.ignoreCookies[_DYN_INDEX_OF](name) !== -1;
  }
  return false;
}
function _isBlockedCookie(cookieMgrCfg, name) {
  if (name && cookieMgrCfg && isArray(cookieMgrCfg.blockedCookies)) {
    if (cookieMgrCfg.blockedCookies[_DYN_INDEX_OF](name) !== -1) {
      return true;
    }
  }
  return _isIgnoredCookie(cookieMgrCfg, name);
}
function safeGetCookieMgr(core, config) {
  var cookieMgr;
  if (core) {
    cookieMgr = core.getCookieMgr();
  } else if (config) {
    var cookieCfg = config[_DYN_COOKIE_CFG];
    if (cookieCfg[strConfigCookieMgr]) {
      cookieMgr = cookieCfg[strConfigCookieMgr];
    } else {
      cookieMgr = createCookieMgr(config);
    }
  }
  if (!cookieMgr) {
    cookieMgr = _gblCookieMgr(config, (core || {})[_DYN_LOGGER]);
  }
  return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
  var _a3;
  var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
  var _path = cookieMgrConfig.path || "/";
  var _domain = cookieMgrConfig.domain;
  var _enabled = cookieMgrConfig[strEnabled] !== false;
  var cookieMgr = (_a3 = {
    isEnabled: function() {
      var enabled = _enabled && areCookiesSupported(logger);
      var gblManager = _globalCookieConfig[strConfigCookieMgr];
      if (enabled && gblManager && cookieMgr !== gblManager) {
        enabled = _isMgrEnabled(gblManager);
      }
      return enabled;
    }
  }, _a3[_DYN_SET_ENABLED] = function(value) {
    _enabled = value !== false;
  }, _a3.set = function(name, value, maxAgeSec, domain, path) {
    var result = false;
    if (_isMgrEnabled(cookieMgr) && !_isBlockedCookie(cookieMgrConfig, name)) {
      var values = {};
      var theValue = strTrim(value || STR_EMPTY);
      var idx = theValue[_DYN_INDEX_OF](";");
      if (idx !== -1) {
        theValue = strTrim(value[_DYN_SUBSTRING](0, idx));
        values = _extractParts(value[_DYN_SUBSTRING](idx + 1));
      }
      setValue(values, "domain", domain || _domain, isTruthy, isUndefined);
      if (!isNullOrUndefined(maxAgeSec)) {
        var _isIE = isIE();
        if (isUndefined(values[strExpires])) {
          var nowMs = dateNow();
          var expireMs = nowMs + maxAgeSec * 1e3;
          if (expireMs > 0) {
            var expiry = new Date();
            expiry.setTime(expireMs);
            setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || STR_EMPTY, isTruthy);
          }
        }
        if (!_isIE) {
          setValue(values, "max-age", STR_EMPTY + maxAgeSec, null, isUndefined);
        }
      }
      var location_1 = getLocation();
      if (location_1 && location_1.protocol === "https:") {
        setValue(values, "secure", null, null, isUndefined);
        if (_allowUaSameSite === null) {
          _allowUaSameSite = !uaDisallowsSameSiteNone((getNavigator() || {})[_DYN_USER_AGENT]);
        }
        if (_allowUaSameSite) {
          setValue(values, "SameSite", "None", null, isUndefined);
        }
      }
      setValue(values, "path", path || _path, null, isUndefined);
      var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
      setCookieFn(name, _formatCookieValue(theValue, values));
      result = true;
    }
    return result;
  }, _a3.get = function(name) {
    var value = STR_EMPTY;
    if (_isMgrEnabled(cookieMgr) && !_isIgnoredCookie(cookieMgrConfig, name)) {
      value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
    }
    return value;
  }, _a3.del = function(name, path) {
    var result = false;
    if (_isMgrEnabled(cookieMgr)) {
      result = cookieMgr.purge(name, path);
    }
    return result;
  }, _a3.purge = function(name, path) {
    var _a4;
    var result = false;
    if (areCookiesSupported(logger)) {
      var values = (_a4 = {}, _a4["path"] = path ? path : "/", _a4[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a4);
      if (!isIE()) {
        values["max-age"] = "0";
      }
      var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
      delCookie(name, _formatCookieValue(STR_EMPTY, values));
      result = true;
    }
    return result;
  }, _a3);
  cookieMgr[strConfigCookieMgr] = cookieMgr;
  return cookieMgr;
}
function areCookiesSupported(logger) {
  if (_supportsCookies === null) {
    _supportsCookies = false;
    try {
      var doc = _doc || {};
      _supportsCookies = doc[strCookie] !== void 0;
    } catch (e) {
      _throwInternal(logger, 2, 68, "Cannot access document.cookie - " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return _supportsCookies;
}
function _extractParts(theValue) {
  var values = {};
  if (theValue && theValue[_DYN_LENGTH]) {
    var parts = strTrim(theValue)[_DYN_SPLIT](";");
    arrForEach(parts, function(thePart) {
      thePart = strTrim(thePart || STR_EMPTY);
      if (thePart) {
        var idx = thePart[_DYN_INDEX_OF]("=");
        if (idx === -1) {
          values[thePart] = null;
        } else {
          values[strTrim(thePart[_DYN_SUBSTRING](0, idx))] = strTrim(thePart[_DYN_SUBSTRING](idx + 1));
        }
      }
    });
  }
  return values;
}
function _formatDate(theDate, func) {
  if (isFunction(theDate[func])) {
    return theDate[func]();
  }
  return null;
}
function _formatCookieValue(value, values) {
  var cookieValue = value || STR_EMPTY;
  objForEachKey(values, function(name, theValue) {
    cookieValue += "; " + name + (!isNullOrUndefined(theValue) ? "=" + theValue : STR_EMPTY);
  });
  return cookieValue;
}
function _getCookieValue(name) {
  var cookieValue = STR_EMPTY;
  if (_doc) {
    var theCookie = _doc[strCookie] || STR_EMPTY;
    if (_parsedCookieValue !== theCookie) {
      _cookieCache = _extractParts(theCookie);
      _parsedCookieValue = theCookie;
    }
    cookieValue = strTrim(_cookieCache[name] || STR_EMPTY);
  }
  return cookieValue;
}
function _setCookieValue(name, cookieValue) {
  if (_doc) {
    _doc[strCookie] = name + "=" + cookieValue;
  }
}
function uaDisallowsSameSiteNone(userAgent) {
  if (!isString(userAgent)) {
    return false;
  }
  if (strContains(userAgent, "CPU iPhone OS 12") || strContains(userAgent, "iPad; CPU OS 12")) {
    return true;
  }
  if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strContains(userAgent, "Version/") && strContains(userAgent, "Safari")) {
    return true;
  }
  if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
    return true;
  }
  if (strContains(userAgent, "Chrome/5") || strContains(userAgent, "Chrome/6")) {
    return true;
  }
  if (strContains(userAgent, "UnrealEngine") && !strContains(userAgent, "Chrome")) {
    return true;
  }
  if (strContains(userAgent, "UCBrowser/12") || strContains(userAgent, "UCBrowser/11")) {
    return true;
  }
  return false;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/RandomHelper.js
var UInt32Mask = 4294967296;
var MaxUInt32 = 4294967295;
var _mwcSeeded = false;
var _mwcW = 123456789;
var _mwcZ = 987654321;
function _mwcSeed(seedValue) {
  if (seedValue < 0) {
    seedValue >>>= 0;
  }
  _mwcW = 123456789 + seedValue & MaxUInt32;
  _mwcZ = 987654321 - seedValue & MaxUInt32;
  _mwcSeeded = true;
}
function _autoSeedMwc() {
  try {
    var now = dateNow() & 2147483647;
    _mwcSeed((Math.random() * UInt32Mask ^ now) + now);
  } catch (e) {
  }
}
function randomValue(maxValue) {
  if (maxValue > 0) {
    return Math.floor(random32() / MaxUInt32 * (maxValue + 1)) >>> 0;
  }
  return 0;
}
function random32(signed) {
  var value = 0;
  var c = getCrypto() || getMsCrypto();
  if (c && c.getRandomValues) {
    value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
  }
  if (value === 0 && isIE()) {
    if (!_mwcSeeded) {
      _autoSeedMwc();
    }
    value = mwcRandom32() & MaxUInt32;
  }
  if (value === 0) {
    value = Math.floor(UInt32Mask * Math.random() | 0);
  }
  if (!signed) {
    value >>>= 0;
  }
  return value;
}
function mwcRandomSeed(value) {
  if (!value) {
    _autoSeedMwc();
  } else {
    _mwcSeed(value);
  }
}
function mwcRandom32(signed) {
  _mwcZ = 36969 * (_mwcZ & 65535) + (_mwcZ >> 16) & MaxUInt32;
  _mwcW = 18e3 * (_mwcW & 65535) + (_mwcW >> 16) & MaxUInt32;
  var value = (_mwcZ << 16) + (_mwcW & 65535) >>> 0 & MaxUInt32 | 0;
  if (!signed) {
    value >>>= 0;
  }
  return value;
}
function newId(maxLength) {
  if (maxLength === void 0) {
    maxLength = 22;
  }
  var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var number = random32() >>> 0;
  var chars = 0;
  var result = STR_EMPTY;
  while (result[_DYN_LENGTH] < maxLength) {
    chars++;
    result += base64chars.charAt(number & 63);
    number >>>= 6;
    if (chars === 5) {
      number = (random32() << 2 & 4294967295 | number & 3) >>> 0;
      chars = 0;
    }
  }
  return result;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/DataCacheHelper.js
var _objDefineProperty2 = ObjDefineProperty;
var version = "2.8.8";
var instanceName = "." + newId(6);
var _dataUid = 0;
function _createAccessor(target, prop, value) {
  if (_objDefineProperty2) {
    try {
      _objDefineProperty2(target, prop, {
        value,
        enumerable: false,
        configurable: true
      });
      return true;
    } catch (e) {
    }
  }
  return false;
}
function _canAcceptData(target) {
  return target[_DYN_NODE_TYPE] === 1 || target[_DYN_NODE_TYPE] === 9 || !+target[_DYN_NODE_TYPE];
}
function _getCache(data, target) {
  var theCache = target[data.id];
  if (!theCache) {
    theCache = {};
    try {
      if (_canAcceptData(target)) {
        if (!_createAccessor(target, data.id, theCache)) {
          target[data.id] = theCache;
        }
      }
    } catch (e) {
    }
  }
  return theCache;
}
function createUniqueNamespace(name, includeVersion) {
  if (includeVersion === void 0) {
    includeVersion = false;
  }
  return normalizeJsName(name + _dataUid++ + (includeVersion ? "." + version : STR_EMPTY) + instanceName);
}
function createElmNodeData(name) {
  var data = {
    id: createUniqueNamespace("_aiData-" + (name || STR_EMPTY) + "." + version),
    accept: function(target) {
      return _canAcceptData(target);
    },
    get: function(target, name2, defValue, addDefault) {
      var theCache = target[data.id];
      if (!theCache) {
        if (addDefault) {
          theCache = _getCache(data, target);
          theCache[normalizeJsName(name2)] = defValue;
        }
        return defValue;
      }
      return theCache[normalizeJsName(name2)];
    },
    kill: function(target, name2) {
      if (target && target[name2]) {
        try {
          delete target[name2];
        } catch (e) {
        }
      }
    }
  };
  return data;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/EventHelpers.js
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var strEvents = "events";
var strVisibilityChangeEvt = "visibilitychange";
var strPageHide = "pagehide";
var strUnload = "unload";
var strBeforeUnload = "beforeunload";
var strPageHideNamespace = createUniqueNamespace("aiEvtPageHide");
var strPageShowNamespace = createUniqueNamespace("aiEvtPageShow");
var rRemoveEmptyNs = /\.[\.]+/g;
var rRemoveTrailingEmptyNs = /[\.]+$/;
var _guid = 1;
var elmNodeData = createElmNodeData("events");
var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function _normalizeNamespace(name) {
  if (name && name[_DYN_REPLACE]) {
    return name.replace(/^\s*\.*|\.*\s*$/g, STR_EMPTY);
  }
  return name;
}
function _getEvtNamespace(eventName, evtNamespace) {
  var _a3;
  if (evtNamespace) {
    var theNamespace_1 = STR_EMPTY;
    if (isArray(evtNamespace)) {
      theNamespace_1 = STR_EMPTY;
      arrForEach(evtNamespace, function(name) {
        name = _normalizeNamespace(name);
        if (name) {
          if (name[0] !== ".") {
            name = "." + name;
          }
          theNamespace_1 += name;
        }
      });
    } else {
      theNamespace_1 = _normalizeNamespace(evtNamespace);
    }
    if (theNamespace_1) {
      if (theNamespace_1[0] !== ".") {
        theNamespace_1 = "." + theNamespace_1;
      }
      eventName = (eventName || STR_EMPTY) + theNamespace_1;
    }
  }
  var parsedEvent = eventNamespace.exec(eventName || STR_EMPTY) || [];
  return _a3 = {}, _a3[_DYN_TYPE] = parsedEvent[1], _a3.ns = (parsedEvent[2] || STR_EMPTY).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, STR_EMPTY)[_DYN_SPLIT](".").sort().join("."), _a3;
}
function _getRegisteredEvents(target, evtName, addDefault) {
  if (addDefault === void 0) {
    addDefault = true;
  }
  var aiEvts = elmNodeData.get(target, strEvents, {}, addDefault);
  var registeredEvents = aiEvts[evtName];
  if (!registeredEvents) {
    registeredEvents = aiEvts[evtName] = [];
  }
  return registeredEvents;
}
function _doDetach(obj, evtName, handlerRef, useCapture) {
  if (obj && evtName && evtName[_DYN_TYPE]) {
    if (obj[strRemoveEventListener]) {
      obj[strRemoveEventListener](evtName[_DYN_TYPE], handlerRef, useCapture);
    } else if (obj[strDetachEvent]) {
      obj[strDetachEvent](strOnPrefix + evtName[_DYN_TYPE], handlerRef);
    }
  }
}
function _doAttach(obj, evtName, handlerRef, useCapture) {
  var result = false;
  if (obj && evtName && evtName[_DYN_TYPE] && handlerRef) {
    if (obj[strAddEventHelper]) {
      obj[strAddEventHelper](evtName[_DYN_TYPE], handlerRef, useCapture);
      result = true;
    } else if (obj[strAttachEvent]) {
      obj[strAttachEvent](strOnPrefix + evtName[_DYN_TYPE], handlerRef);
      result = true;
    }
  }
  return result;
}
function _doUnregister(target, events, evtName, unRegFn) {
  var idx = events[_DYN_LENGTH];
  while (idx--) {
    var theEvent = events[idx];
    if (theEvent) {
      if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
        if (!unRegFn || unRegFn(theEvent)) {
          _doDetach(target, theEvent.evtName, theEvent[_DYN_HANDLER], theEvent.capture);
          events[_DYN_SPLICE](idx, 1);
        }
      }
    }
  }
}
function _unregisterEvents(target, evtName, unRegFn) {
  if (evtName[_DYN_TYPE]) {
    _doUnregister(target, _getRegisteredEvents(target, evtName[_DYN_TYPE]), evtName, unRegFn);
  } else {
    var eventCache = elmNodeData.get(target, strEvents, {});
    objForEachKey(eventCache, function(evtType, events) {
      _doUnregister(target, events, evtName, unRegFn);
    });
    if (objKeys(eventCache)[_DYN_LENGTH] === 0) {
      elmNodeData.kill(target, strEvents);
    }
  }
}
function mergeEvtNamespace(theNamespace, namespaces) {
  var newNamespaces;
  if (namespaces) {
    if (isArray(namespaces)) {
      newNamespaces = [theNamespace].concat(namespaces);
    } else {
      newNamespaces = [theNamespace, namespaces];
    }
    newNamespaces = _getEvtNamespace("xx", newNamespaces).ns[_DYN_SPLIT](".");
  } else {
    newNamespaces = theNamespace;
  }
  return newNamespaces;
}
function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
  var _a3;
  if (useCapture === void 0) {
    useCapture = false;
  }
  var result = false;
  if (target) {
    try {
      var evtName = _getEvtNamespace(eventName, evtNamespace);
      result = _doAttach(target, evtName, handlerRef, useCapture);
      if (result && elmNodeData.accept(target)) {
        var registeredEvent = (_a3 = {
          guid: _guid++,
          evtName
        }, _a3[_DYN_HANDLER] = handlerRef, _a3.capture = useCapture, _a3);
        _getRegisteredEvents(target, evtName.type)[_DYN_PUSH](registeredEvent);
      }
    } catch (e) {
    }
  }
  return result;
}
function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
  if (useCapture === void 0) {
    useCapture = false;
  }
  if (target) {
    try {
      var evtName_1 = _getEvtNamespace(eventName, evtNamespace);
      var found_1 = false;
      _unregisterEvents(target, evtName_1, function(regEvent) {
        if (evtName_1.ns && !handlerRef || regEvent[_DYN_HANDLER] === handlerRef) {
          found_1 = true;
          return true;
        }
        return false;
      });
      if (!found_1) {
        _doDetach(target, evtName_1, handlerRef, useCapture);
      }
    } catch (e) {
    }
  }
}
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
  if (useCapture === void 0) {
    useCapture = false;
  }
  return eventOn(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function addEventHandler(eventName, callback, evtNamespace) {
  var result = false;
  var w = getWindow();
  if (w) {
    result = eventOn(w, eventName, callback, evtNamespace);
    result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
  }
  var doc = getDocument();
  if (doc) {
    result = eventOn(doc, eventName, callback, evtNamespace) || result;
  }
  return result;
}
function removeEventHandler(eventName, callback, evtNamespace) {
  var w = getWindow();
  if (w) {
    eventOff(w, eventName, callback, evtNamespace);
    eventOff(w["body"], eventName, callback, evtNamespace);
  }
  var doc = getDocument();
  if (doc) {
    eventOff(doc, eventName, callback, evtNamespace);
  }
}
function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
  var added = false;
  if (listener && events && events[_DYN_LENGTH] > 0) {
    arrForEach(events, function(name) {
      if (name) {
        if (!excludeEvents || arrIndexOf(excludeEvents, name) === -1) {
          added = addEventHandler(name, listener, evtNamespace) || added;
        }
      }
    });
  }
  return added;
}
function addEventListeners(events, listener, excludeEvents, evtNamespace) {
  var added = false;
  if (listener && events && isArray(events)) {
    added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
    if (!added && excludeEvents && excludeEvents[_DYN_LENGTH] > 0) {
      added = _addEventListeners(events, listener, null, evtNamespace);
    }
  }
  return added;
}
function removeEventListeners(events, listener, evtNamespace) {
  if (events && isArray(events)) {
    arrForEach(events, function(name) {
      if (name) {
        removeEventHandler(name, listener, evtNamespace);
      }
    });
  }
}
function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
  return addEventListeners([strBeforeUnload, strUnload, strPageHide], listener, excludeEvents, evtNamespace);
}
function removePageUnloadEventListener(listener, evtNamespace) {
  removeEventListeners([strBeforeUnload, strUnload, strPageHide], listener, evtNamespace);
}
function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
  function _handlePageVisibility(evt) {
    var doc = getDocument();
    if (listener && doc && doc.visibilityState === "hidden") {
      listener(evt);
    }
  }
  var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
  var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
  if (!excludeEvents || arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) {
    pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
  }
  if (!pageUnloadAdded && excludeEvents) {
    pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
  }
  return pageUnloadAdded;
}
function removePageHideEventListener(listener, evtNamespace) {
  var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
  removeEventListeners([strPageHide], listener, newNamespaces);
  removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/CoreUtils.js
var _cookieMgrs = null;
var _canUseCookies;
function newGuid() {
  var uuid = generateW3CId();
  return uuid[_DYN_SUBSTRING](0, 8) + "-" + uuid[_DYN_SUBSTRING](8, 12) + "-" + uuid[_DYN_SUBSTRING](12, 16) + "-" + uuid[_DYN_SUBSTRING](16, 20) + "-" + uuid[_DYN_SUBSTRING](20);
}
function perfNow() {
  var perf = getPerformance();
  if (perf && perf.now) {
    return perf.now();
  }
  return dateNow();
}
function generateW3CId() {
  var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
  var oct = STR_EMPTY, tmp;
  for (var a = 0; a < 4; a++) {
    tmp = random32();
    oct += hexValues[tmp & 15] + hexValues[tmp >> 4 & 15] + hexValues[tmp >> 8 & 15] + hexValues[tmp >> 12 & 15] + hexValues[tmp >> 16 & 15] + hexValues[tmp >> 20 & 15] + hexValues[tmp >> 24 & 15] + hexValues[tmp >> 28 & 15];
  }
  var clockSequenceHi = hexValues[8 + (random32() & 3) | 0];
  return oct[_DYN_SUBSTR](0, 8) + oct[_DYN_SUBSTR](9, 4) + "4" + oct[_DYN_SUBSTR](13, 3) + clockSequenceHi + oct[_DYN_SUBSTR](16, 3) + oct[_DYN_SUBSTR](19, 12);
}
var CoreUtils = {
  _canUseCookies: void 0,
  isTypeof,
  isUndefined,
  isNullOrUndefined,
  hasOwnProperty,
  isFunction,
  isObject,
  isDate,
  isArray,
  isError,
  isString,
  isNumber,
  isBoolean,
  toISOString,
  arrForEach,
  arrIndexOf,
  arrMap,
  arrReduce,
  strTrim,
  objCreate: objCreateFn,
  objKeys,
  objDefineAccessors,
  addEventHandler,
  dateNow,
  isIE,
  disableCookies,
  newGuid,
  perfNow,
  newId,
  randomValue,
  random32,
  mwcRandomSeed,
  mwcRandom32,
  generateW3CId
};
function _legacyCookieMgr(config, logger) {
  var cookieMgr = _gblCookieMgr(config, logger);
  var legacyCanUseCookies = CoreUtils._canUseCookies;
  if (_cookieMgrs === null) {
    _cookieMgrs = [];
    _canUseCookies = legacyCanUseCookies;
    objDefineAccessors(CoreUtils, "_canUseCookies", function() {
      return _canUseCookies;
    }, function(value) {
      _canUseCookies = value;
      arrForEach(_cookieMgrs, function(mgr) {
        mgr[_DYN_SET_ENABLED](value);
      });
    });
  }
  if (arrIndexOf(_cookieMgrs, cookieMgr) === -1) {
    _cookieMgrs[_DYN_PUSH](cookieMgr);
  }
  if (isBoolean(legacyCanUseCookies)) {
    cookieMgr[_DYN_SET_ENABLED](legacyCanUseCookies);
  }
  if (isBoolean(_canUseCookies)) {
    cookieMgr[_DYN_SET_ENABLED](_canUseCookies);
  }
  return cookieMgr;
}
function disableCookies() {
  _legacyCookieMgr()[_DYN_SET_ENABLED](false);
}
function canUseCookies(logger) {
  return _legacyCookieMgr(null, logger).isEnabled();
}
function getCookie(logger, name) {
  return _legacyCookieMgr(null, logger).get(name);
}
function setCookie(logger, name, value, domain) {
  _legacyCookieMgr(null, logger).set(name, value, null, domain);
}
function deleteCookie(logger, name) {
  return _legacyCookieMgr(null, logger).del(name);
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/W3cTraceParent.js
var DEFAULT_VERSION = "00";
var INVALID_VERSION = "ff";
var INVALID_TRACE_ID = "00000000000000000000000000000000";
var INVALID_SPAN_ID = "0000000000000000";
function _isValid(value, len, invalidValue) {
  if (value && value[_DYN_LENGTH] === len && value !== invalidValue) {
    return !!value.match(/^[\da-f]*$/);
  }
  return false;
}
function _formatValue(value, len, defValue) {
  if (_isValid(value, len)) {
    return value;
  }
  return defValue;
}
function _formatFlags(value) {
  if (isNaN(value) || value < 0 || value > 255) {
    value = 1;
  }
  var result = value.toString(16);
  while (result[_DYN_LENGTH] < 2) {
    result = "0" + result;
  }
  return result;
}
function createTraceParent(traceId, spanId, flags, version2) {
  var _a3;
  return _a3 = {}, _a3[_DYN_VERSION] = _isValid(version2, 2, INVALID_VERSION) ? version2 : DEFAULT_VERSION, _a3[_DYN_TRACE_ID] = isValidTraceId(traceId) ? traceId : generateW3CId(), _a3.spanId = isValidSpanId(spanId) ? spanId : generateW3CId()[_DYN_SUBSTR](0, 16), _a3.traceFlags = flags >= 0 && flags <= 255 ? flags : 1, _a3;
}
function isValidTraceId(value) {
  return _isValid(value, 32, INVALID_TRACE_ID);
}
function isValidSpanId(value) {
  return _isValid(value, 16, INVALID_SPAN_ID);
}
function formatTraceParent(value) {
  if (value) {
    var flags = _formatFlags(value[_DYN_TRACE_FLAGS]);
    if (!_isValid(flags, 2)) {
      flags = "01";
    }
    var version2 = value[_DYN_VERSION] || DEFAULT_VERSION;
    if (version2 !== "00" && version2 !== "ff") {
      version2 = DEFAULT_VERSION;
    }
    return "".concat(version2, "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID), "-").concat(flags);
  }
  return "";
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/TelemetryHelpers.js
var pluginStateData = createElmNodeData("plugin");
function _getPluginState(plugin) {
  return pluginStateData.get(plugin, "state", {}, true);
}
function initializePlugins(processContext, extensions) {
  var initPlugins = [];
  var lastPlugin = null;
  var proxy = processContext[_DYN_GET_NEXT]();
  var pluginState;
  while (proxy) {
    var thePlugin = proxy[_DYN_GET_PLUGIN]();
    if (thePlugin) {
      if (lastPlugin && isFunction(lastPlugin[_DYN_SET_NEXT_PLUGIN]) && isFunction(thePlugin[STR_PROCESS_TELEMETRY])) {
        lastPlugin[_DYN_SET_NEXT_PLUGIN](thePlugin);
      }
      var isInitialized = false;
      if (isFunction(thePlugin[_DYN_IS_INITIALIZED])) {
        isInitialized = thePlugin[_DYN_IS_INITIALIZED]();
      } else {
        pluginState = _getPluginState(thePlugin);
        isInitialized = pluginState[_DYN_IS_INITIALIZED];
      }
      if (!isInitialized) {
        initPlugins[_DYN_PUSH](thePlugin);
      }
      lastPlugin = thePlugin;
      proxy = proxy[_DYN_GET_NEXT]();
    }
  }
  arrForEach(initPlugins, function(thePlugin2) {
    var core = processContext[STR_CORE]();
    thePlugin2[_DYN_INITIALIZE](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT]());
    pluginState = _getPluginState(thePlugin2);
    if (!thePlugin2[STR_CORE] && !pluginState[STR_CORE]) {
      pluginState[STR_CORE] = core;
    }
    pluginState[_DYN_IS_INITIALIZED] = true;
    delete pluginState[_DYN_TEARDOWN];
  });
}
function sortPlugins(plugins) {
  return plugins.sort(function(extA, extB) {
    var result = 0;
    if (extB) {
      var bHasProcess = isFunction(extB[STR_PROCESS_TELEMETRY]);
      if (isFunction(extA[STR_PROCESS_TELEMETRY])) {
        result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
      } else if (bHasProcess) {
        result = -1;
      }
    } else {
      result = extA ? 1 : -1;
    }
    return result;
  });
}
function createDistributedTraceContext(parentCtx) {
  var trace = {};
  return {
    getName: function() {
      return trace[_DYN_NAME];
    },
    setName: function(newValue) {
      parentCtx && parentCtx.setName(newValue);
      trace[_DYN_NAME] = newValue;
    },
    getTraceId: function() {
      return trace[_DYN_TRACE_ID];
    },
    setTraceId: function(newValue) {
      parentCtx && parentCtx.setTraceId(newValue);
      if (isValidTraceId(newValue)) {
        trace[_DYN_TRACE_ID] = newValue;
      }
    },
    getSpanId: function() {
      return trace[_DYN_SPAN_ID];
    },
    setSpanId: function(newValue) {
      parentCtx && parentCtx.setSpanId(newValue);
      if (isValidSpanId(newValue)) {
        trace[_DYN_SPAN_ID] = newValue;
      }
    },
    getTraceFlags: function() {
      return trace[_DYN_TRACE_FLAGS];
    },
    setTraceFlags: function(newTraceFlags) {
      parentCtx && parentCtx.setTraceFlags(newTraceFlags);
      trace[_DYN_TRACE_FLAGS] = newTraceFlags;
    }
  };
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/ProcessTelemetryContext.js
var strTelemetryPluginChain = "TelemetryPluginChain";
var strHasRunFlags = "_hasRun";
var strGetTelCtx = "_getTelCtx";
var _chainId = 0;
function _getNextProxyStart(proxy, core, startAt) {
  while (proxy) {
    if (proxy[_DYN_GET_PLUGIN]() === startAt) {
      return proxy;
    }
    proxy = proxy[_DYN_GET_NEXT]();
  }
  return createTelemetryProxyChain([startAt], core[_DYN_CONFIG] || {}, core);
}
function _createInternalContext(telemetryChain, config, core, startAt) {
  var _nextProxy = null;
  var _onComplete = [];
  if (startAt !== null) {
    _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
  }
  var context = {
    _next: _moveNext,
    ctx: {
      core: function() {
        return core;
      },
      diagLog: function() {
        return safeGetLogger(core, config);
      },
      getCfg: function() {
        return config;
      },
      getExtCfg: _getExtCfg,
      getConfig: _getConfig,
      hasNext: function() {
        return !!_nextProxy;
      },
      getNext: function() {
        return _nextProxy;
      },
      setNext: function(nextPlugin) {
        _nextProxy = nextPlugin;
      },
      iterate: _iterateChain,
      onComplete: _addOnComplete
    }
  };
  function _addOnComplete(onComplete, that) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    if (onComplete) {
      _onComplete[_DYN_PUSH]({
        func: onComplete,
        self: !isUndefined(that) ? that : context.ctx,
        args
      });
    }
  }
  function _moveNext() {
    var nextProxy = _nextProxy;
    _nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT]() : null;
    if (!nextProxy) {
      var onComplete = _onComplete;
      if (onComplete && onComplete[_DYN_LENGTH] > 0) {
        arrForEach(onComplete, function(completeDetails) {
          try {
            completeDetails.func[_DYN_CALL](completeDetails.self, completeDetails.args);
          } catch (e) {
            _throwInternal(core[_DYN_LOGGER], 2, 73, "Unexpected Exception during onComplete - " + dumpObj(e));
          }
        });
        _onComplete = [];
      }
    }
    return nextProxy;
  }
  function _getExtCfg(identifier, defaultValue, mergeDefault) {
    if (defaultValue === void 0) {
      defaultValue = {};
    }
    if (mergeDefault === void 0) {
      mergeDefault = 0;
    }
    var theConfig;
    if (config) {
      var extConfig = config[STR_EXTENSION_CONFIG];
      if (extConfig && identifier) {
        theConfig = extConfig[identifier];
      }
    }
    if (!theConfig) {
      theConfig = defaultValue;
    } else if (isObject(defaultValue)) {
      if (mergeDefault !== 0) {
        var newConfig_1 = objExtend(true, defaultValue, theConfig);
        if (config && mergeDefault === 2) {
          objForEachKey(defaultValue, function(field) {
            if (isNullOrUndefined(newConfig_1[field])) {
              var cfgValue = config[field];
              if (!isNullOrUndefined(cfgValue)) {
                newConfig_1[field] = cfgValue;
              }
            }
          });
        }
        theConfig = newConfig_1;
      }
    }
    return theConfig;
  }
  function _getConfig(identifier, field, defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = false;
    }
    var theValue;
    var extConfig = _getExtCfg(identifier, null);
    if (extConfig && !isNullOrUndefined(extConfig[field])) {
      theValue = extConfig[field];
    } else if (config && !isNullOrUndefined(config[field])) {
      theValue = config[field];
    }
    return !isNullOrUndefined(theValue) ? theValue : defaultValue;
  }
  function _iterateChain(cb) {
    var nextPlugin;
    while (!!(nextPlugin = context._next())) {
      var plugin = nextPlugin[_DYN_GET_PLUGIN]();
      if (plugin) {
        cb(plugin);
      }
    }
  }
  return context;
}
function createProcessTelemetryContext(telemetryChain, config, core, startAt) {
  var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
  var context = internalContext.ctx;
  function _processNext(env) {
    var nextPlugin = internalContext._next();
    nextPlugin && nextPlugin[STR_PROCESS_TELEMETRY](env, context);
    return !nextPlugin;
  }
  function _createNew(plugins, startAt2) {
    if (plugins === void 0) {
      plugins = null;
    }
    if (isArray(plugins)) {
      plugins = createTelemetryProxyChain(plugins, config, core, startAt2);
    }
    return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT](), config, core, startAt2);
  }
  context[_DYN_PROCESS_NEXT] = _processNext;
  context[_DYN_CREATE_NEW] = _createNew;
  return context;
}
function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
  var config = core[_DYN_CONFIG] || {};
  var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
  var context = internalContext.ctx;
  function _processNext(unloadState) {
    var nextPlugin = internalContext._next();
    nextPlugin && nextPlugin.unload(context, unloadState);
    return !nextPlugin;
  }
  function _createNew(plugins, startAt2) {
    if (plugins === void 0) {
      plugins = null;
    }
    if (isArray(plugins)) {
      plugins = createTelemetryProxyChain(plugins, config, core, startAt2);
    }
    return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT](), core, startAt2);
  }
  context[_DYN_PROCESS_NEXT] = _processNext;
  context[_DYN_CREATE_NEW] = _createNew;
  return context;
}
function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
  var config = core[_DYN_CONFIG] || {};
  var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
  var context = internalContext.ctx;
  function _processNext(updateState) {
    return context.iterate(function(plugin) {
      if (isFunction(plugin[_DYN_UPDATE])) {
        plugin[_DYN_UPDATE](context, updateState);
      }
    });
  }
  function _createNew(plugins, startAt2) {
    if (plugins === void 0) {
      plugins = null;
    }
    if (isArray(plugins)) {
      plugins = createTelemetryProxyChain(plugins, config, core, startAt2);
    }
    return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT](), core, startAt2);
  }
  context[_DYN_PROCESS_NEXT] = _processNext;
  context[_DYN_CREATE_NEW] = _createNew;
  return context;
}
function createTelemetryProxyChain(plugins, config, core, startAt) {
  var firstProxy = null;
  var add = startAt ? false : true;
  if (isArray(plugins) && plugins[_DYN_LENGTH] > 0) {
    var lastProxy_1 = null;
    arrForEach(plugins, function(thePlugin) {
      if (!add && startAt === thePlugin) {
        add = true;
      }
      if (add && thePlugin && isFunction(thePlugin[STR_PROCESS_TELEMETRY])) {
        var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
        if (!firstProxy) {
          firstProxy = newProxy;
        }
        if (lastProxy_1) {
          lastProxy_1._setNext(newProxy);
        }
        lastProxy_1 = newProxy;
      }
    });
  }
  if (startAt && !firstProxy) {
    return createTelemetryProxyChain([startAt], config, core);
  }
  return firstProxy;
}
function createTelemetryPluginProxy(plugin, config, core) {
  var nextProxy = null;
  var hasProcessTelemetry = isFunction(plugin[STR_PROCESS_TELEMETRY]);
  var hasSetNext = isFunction(plugin[_DYN_SET_NEXT_PLUGIN]);
  var chainId;
  if (plugin) {
    chainId = plugin[_DYN_IDENTIFIER] + "-" + plugin[STR_PRIORITY] + "-" + _chainId++;
  } else {
    chainId = "Unknown-0-" + _chainId++;
  }
  var proxyChain = {
    getPlugin: function() {
      return plugin;
    },
    getNext: function() {
      return nextProxy;
    },
    processTelemetry: _processTelemetry,
    unload: _unloadPlugin,
    update: _updatePlugin,
    _id: chainId,
    _setNext: function(nextPlugin) {
      nextProxy = nextPlugin;
    }
  };
  function _getTelCtx() {
    var itemCtx;
    if (plugin && isFunction(plugin[strGetTelCtx])) {
      itemCtx = plugin[strGetTelCtx]();
    }
    if (!itemCtx) {
      itemCtx = createProcessTelemetryContext(proxyChain, config, core);
    }
    return itemCtx;
  }
  function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
    var hasRun = false;
    var identifier = plugin ? plugin[_DYN_IDENTIFIER] : strTelemetryPluginChain;
    var hasRunContext = itemCtx[strHasRunFlags];
    if (!hasRunContext) {
      hasRunContext = itemCtx[strHasRunFlags] = {};
    }
    itemCtx.setNext(nextProxy);
    if (plugin) {
      doPerf(itemCtx[STR_CORE](), function() {
        return identifier + ":" + name;
      }, function() {
        hasRunContext[chainId] = true;
        try {
          var nextId = nextProxy ? nextProxy._id : STR_EMPTY;
          if (nextId) {
            hasRunContext[nextId] = false;
          }
          hasRun = processPluginFn(itemCtx);
        } catch (error) {
          var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
          if (hasNextRun) {
            hasRun = true;
          }
          if (!nextProxy || !hasNextRun) {
            _throwInternal(itemCtx[_DYN_DIAG_LOG](), 1, 73, "Plugin [" + identifier + "] failed during " + name + " - " + dumpObj(error) + ", run flags: " + dumpObj(hasRunContext));
          }
        }
      }, details, isAsync);
    }
    return hasRun;
  }
  function _processTelemetry(env, itemCtx) {
    itemCtx = itemCtx || _getTelCtx();
    function _callProcessTelemetry(itemCtx2) {
      if (!plugin || !hasProcessTelemetry) {
        return false;
      }
      var pluginState = _getPluginState(plugin);
      if (pluginState[_DYN_TEARDOWN] || pluginState[STR_DISABLED]) {
        return false;
      }
      if (hasSetNext) {
        plugin[_DYN_SET_NEXT_PLUGIN](nextProxy);
      }
      plugin[STR_PROCESS_TELEMETRY](env, itemCtx2);
      return true;
    }
    if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function() {
      return { item: env };
    }, !env.sync)) {
      itemCtx[_DYN_PROCESS_NEXT](env);
    }
  }
  function _unloadPlugin(unloadCtx, unloadState) {
    function _callTeardown() {
      var hasRun = false;
      if (plugin) {
        var pluginState = _getPluginState(plugin);
        var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE];
        if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN]) {
          pluginState[STR_CORE] = null;
          pluginState[_DYN_TEARDOWN] = true;
          pluginState[_DYN_IS_INITIALIZED] = false;
          if (plugin[_DYN_TEARDOWN] && plugin[_DYN_TEARDOWN](unloadCtx, unloadState) === true) {
            hasRun = true;
          }
        }
      }
      return hasRun;
    }
    if (!_processChain(unloadCtx, _callTeardown, "unload", function() {
    }, unloadState[_DYN_IS_ASYNC])) {
      unloadCtx[_DYN_PROCESS_NEXT](unloadState);
    }
  }
  function _updatePlugin(updateCtx, updateState) {
    function _callUpdate() {
      var hasRun = false;
      if (plugin) {
        var pluginState = _getPluginState(plugin);
        var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE];
        if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN]) {
          if (plugin[_DYN_UPDATE] && plugin[_DYN_UPDATE](updateCtx, updateState) === true) {
            hasRun = true;
          }
        }
      }
      return hasRun;
    }
    if (!_processChain(updateCtx, _callUpdate, "update", function() {
    }, false)) {
      updateCtx[_DYN_PROCESS_NEXT](updateState);
    }
  }
  return objFreeze(proxyChain);
}
var ProcessTelemetryContext = function() {
  function ProcessTelemetryContext2(pluginChain, config, core, startAt) {
    var _self = this;
    var context = createProcessTelemetryContext(pluginChain, config, core, startAt);
    proxyFunctions(_self, context, objKeys(context));
  }
  return ProcessTelemetryContext2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/UnloadHandlerContainer.js
function createUnloadHandlerContainer() {
  var handlers = [];
  function _addHandler(handler) {
    if (handler) {
      handlers[_DYN_PUSH](handler);
    }
  }
  function _runHandlers(unloadCtx, unloadState) {
    arrForEach(handlers, function(handler) {
      try {
        handler(unloadCtx, unloadState);
      } catch (e) {
        _throwInternal(unloadCtx[_DYN_DIAG_LOG](), 2, 73, "Unexpected error calling unload handler - " + dumpObj(e));
      }
    });
    handlers = [];
  }
  return {
    add: _addHandler,
    run: _runHandlers
  };
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/BaseTelemetryPlugin.js
var strGetPlugin = "getPlugin";
var BaseTelemetryPlugin = function() {
  function BaseTelemetryPlugin2() {
    var _self = this;
    var _isinitialized;
    var _rootCtx;
    var _nextPlugin;
    var _unloadHandlerContainer;
    var _hooks;
    _initDefaults();
    dynamicProto(BaseTelemetryPlugin2, _self, function(_self2) {
      _self2[_DYN_INITIALIZE] = function(config, core, extensions, pluginChain) {
        _setDefaults(config, core, pluginChain);
        _isinitialized = true;
      };
      _self2[_DYN_TEARDOWN] = function(unloadCtx, unloadState) {
        var _a3;
        var core = _self2[STR_CORE];
        if (!core || unloadCtx && core !== unloadCtx[STR_CORE]()) {
          return;
        }
        var result;
        var unloadDone = false;
        var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
        var theUnloadState = unloadState || (_a3 = {
          reason: 0
        }, _a3[_DYN_IS_ASYNC] = false, _a3);
        function _unloadCallback() {
          if (!unloadDone) {
            unloadDone = true;
            _unloadHandlerContainer.run(theUnloadCtx, unloadState);
            var oldHooks = _hooks;
            _hooks = [];
            arrForEach(oldHooks, function(fn) {
              fn.rm();
            });
            if (result === true) {
              theUnloadCtx[_DYN_PROCESS_NEXT](theUnloadState);
            }
            _initDefaults();
          }
        }
        if (!_self2[_DYN__DO_TEARDOWN] || _self2[_DYN__DO_TEARDOWN](theUnloadCtx, theUnloadState, _unloadCallback) !== true) {
          _unloadCallback();
        } else {
          result = true;
        }
        return result;
      };
      _self2[_DYN_UPDATE] = function(updateCtx, updateState) {
        var core = _self2[STR_CORE];
        if (!core || updateCtx && core !== updateCtx[STR_CORE]()) {
          return;
        }
        var result;
        var updateDone = false;
        var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
        var theUpdateState = updateState || {
          reason: 0
        };
        function _updateCallback() {
          if (!updateDone) {
            updateDone = true;
            _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT]());
          }
        }
        if (!_self2._doUpdate || _self2._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) {
          _updateCallback();
        } else {
          result = true;
        }
        return result;
      };
      _self2._addHook = function(hooks) {
        if (hooks) {
          if (isArray(hooks)) {
            _hooks = _hooks.concat(hooks);
          } else {
            _hooks[_DYN_PUSH](hooks);
          }
        }
      };
      proxyFunctionAs(_self2, "_addUnloadCb", function() {
        return _unloadHandlerContainer;
      }, "add");
    });
    _self[_DYN_DIAG_LOG] = function(itemCtx) {
      return _getTelCtx(itemCtx)[_DYN_DIAG_LOG]();
    };
    _self[_DYN_IS_INITIALIZED] = function() {
      return _isinitialized;
    };
    _self.setInitialized = function(isInitialized) {
      _isinitialized = isInitialized;
    };
    _self[_DYN_SET_NEXT_PLUGIN] = function(next) {
      _nextPlugin = next;
    };
    _self[_DYN_PROCESS_NEXT] = function(env, itemCtx) {
      if (itemCtx) {
        itemCtx[_DYN_PROCESS_NEXT](env);
      } else if (_nextPlugin && isFunction(_nextPlugin[STR_PROCESS_TELEMETRY])) {
        _nextPlugin[STR_PROCESS_TELEMETRY](env, null);
      }
    };
    _self._getTelCtx = _getTelCtx;
    function _getTelCtx(currentCtx) {
      if (currentCtx === void 0) {
        currentCtx = null;
      }
      var itemCtx = currentCtx;
      if (!itemCtx) {
        var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE]);
        if (_nextPlugin && _nextPlugin[strGetPlugin]) {
          itemCtx = rootCtx[_DYN_CREATE_NEW](null, _nextPlugin[strGetPlugin]);
        } else {
          itemCtx = rootCtx[_DYN_CREATE_NEW](null, _nextPlugin);
        }
      }
      return itemCtx;
    }
    function _setDefaults(config, core, pluginChain) {
      if (config) {
        setValue(config, STR_EXTENSION_CONFIG, [], null, isNullOrUndefined);
      }
      if (!pluginChain && core) {
        pluginChain = core[_DYN_GET_PROCESS_TEL_CONT0]()[_DYN_GET_NEXT]();
      }
      var nextPlugin = _nextPlugin;
      if (_nextPlugin && _nextPlugin[strGetPlugin]) {
        nextPlugin = _nextPlugin[strGetPlugin]();
      }
      _self[STR_CORE] = core;
      _rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
    }
    function _initDefaults() {
      _isinitialized = false;
      _self[STR_CORE] = null;
      _rootCtx = null;
      _nextPlugin = null;
      _hooks = [];
      _unloadHandlerContainer = createUnloadHandlerContainer();
    }
  }
  BaseTelemetryPlugin2.__ieDyn = 1;
  return BaseTelemetryPlugin2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/ChannelController.js
var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority - ";
function _addChannelQueue(channelQueue, queue, core) {
  if (queue && isArray(queue) && queue[_DYN_LENGTH] > 0) {
    queue = queue.sort(function(a, b) {
      return a[STR_PRIORITY] - b[STR_PRIORITY];
    });
    arrForEach(queue, function(queueItem) {
      if (queueItem[STR_PRIORITY] < ChannelControllerPriority) {
        throwError(ChannelValidationMessage + queueItem[_DYN_IDENTIFIER]);
      }
    });
    channelQueue[_DYN_PUSH]({
      queue: objFreeze(queue),
      chain: createTelemetryProxyChain(queue, core[_DYN_CONFIG], core)
    });
  }
}
function createChannelControllerPlugin(channelQueue, core) {
  function _getTelCtx() {
    return createProcessTelemetryContext(null, core[_DYN_CONFIG], core, null);
  }
  function _processChannelQueue(theChannels, itemCtx, processFn, onComplete) {
    var waiting = theChannels ? theChannels[_DYN_LENGTH] + 1 : 1;
    function _runChainOnComplete() {
      waiting--;
      if (waiting === 0) {
        onComplete && onComplete();
        onComplete = null;
      }
    }
    if (waiting > 0) {
      arrForEach(theChannels, function(channels) {
        if (channels && channels.queue[_DYN_LENGTH] > 0) {
          var channelChain = channels.chain;
          var chainCtx = itemCtx[_DYN_CREATE_NEW](channelChain);
          chainCtx[_DYN_ON_COMPLETE](_runChainOnComplete);
          processFn(chainCtx);
        } else {
          waiting--;
        }
      });
    }
    _runChainOnComplete();
  }
  function _doUpdate(updateCtx, updateState) {
    var theUpdateState = updateState || {
      reason: 0
    };
    _processChannelQueue(channelQueue, updateCtx, function(chainCtx) {
      chainCtx[_DYN_PROCESS_NEXT](theUpdateState);
    }, function() {
      updateCtx[_DYN_PROCESS_NEXT](theUpdateState);
    });
    return true;
  }
  function _doTeardown(unloadCtx, unloadState) {
    var theUnloadState = unloadState || {
      reason: 0,
      isAsync: false
    };
    _processChannelQueue(channelQueue, unloadCtx, function(chainCtx) {
      chainCtx[_DYN_PROCESS_NEXT](theUnloadState);
    }, function() {
      unloadCtx[_DYN_PROCESS_NEXT](theUnloadState);
      isInitialized = false;
    });
    return true;
  }
  function _getChannel(pluginIdentifier) {
    var thePlugin = null;
    if (channelQueue && channelQueue[_DYN_LENGTH] > 0) {
      arrForEach(channelQueue, function(channels) {
        if (channels && channels.queue[_DYN_LENGTH] > 0) {
          arrForEach(channels.queue, function(ext) {
            if (ext[_DYN_IDENTIFIER] === pluginIdentifier) {
              thePlugin = ext;
              return -1;
            }
          });
          if (thePlugin) {
            return -1;
          }
        }
      });
    }
    return thePlugin;
  }
  var isInitialized = false;
  var channelController = {
    identifier: "ChannelControllerPlugin",
    priority: ChannelControllerPriority,
    initialize: function(config, core2, extensions, pluginChain) {
      isInitialized = true;
      arrForEach(channelQueue, function(channels) {
        if (channels && channels.queue[_DYN_LENGTH] > 0) {
          initializePlugins(createProcessTelemetryContext(channels.chain, config, core2), extensions);
        }
      });
    },
    isInitialized: function() {
      return isInitialized;
    },
    processTelemetry: function(item, itemCtx) {
      _processChannelQueue(channelQueue, itemCtx || _getTelCtx(), function(chainCtx) {
        chainCtx[_DYN_PROCESS_NEXT](item);
      }, function() {
        itemCtx[_DYN_PROCESS_NEXT](item);
      });
    },
    update: _doUpdate,
    pause: function() {
      _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
        chainCtx.iterate(function(plugin) {
          plugin.pause && plugin.pause();
        });
      }, null);
    },
    resume: function() {
      _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
        chainCtx.iterate(function(plugin) {
          plugin.resume && plugin.resume();
        });
      }, null);
    },
    teardown: _doTeardown,
    getChannel: _getChannel,
    flush: function(isAsync, callBack, sendReason, cbTimeout) {
      var waiting = 1;
      var doneIterating = false;
      var cbTimer = null;
      cbTimeout = cbTimeout || 5e3;
      function doCallback() {
        waiting--;
        if (doneIterating && waiting === 0) {
          if (cbTimer) {
            clearTimeout(cbTimer);
            cbTimer = null;
          }
          callBack && callBack(doneIterating);
          callBack = null;
        }
      }
      _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
        chainCtx.iterate(function(plugin) {
          if (plugin[_DYN_FLUSH]) {
            waiting++;
            var handled_1 = false;
            if (!plugin[_DYN_FLUSH](isAsync, function() {
              handled_1 = true;
              doCallback();
            }, sendReason)) {
              if (!handled_1) {
                if (isAsync && cbTimer == null) {
                  cbTimer = setTimeout(function() {
                    cbTimer = null;
                    doCallback();
                  }, cbTimeout);
                } else {
                  doCallback();
                }
              }
            }
          }
        });
      }, function() {
        doneIterating = true;
        doCallback();
      });
      return true;
    },
    _setQueue: function(queue) {
      channelQueue = queue;
    }
  };
  return channelController;
}
function createChannelQueues(channels, extensions, core) {
  var channelQueue = [];
  if (channels) {
    arrForEach(channels, function(queue) {
      return _addChannelQueue(channelQueue, queue, core);
    });
  }
  if (extensions) {
    var extensionQueue_1 = [];
    arrForEach(extensions, function(plugin) {
      if (plugin[STR_PRIORITY] > ChannelControllerPriority) {
        extensionQueue_1[_DYN_PUSH](plugin);
      }
    });
    _addChannelQueue(channelQueue, extensionQueue_1, core);
  }
  return channelQueue;
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/TelemetryInitializerPlugin.js
var TelemetryInitializerPlugin = function(_super) {
  __extendsFn(TelemetryInitializerPlugin2, _super);
  function TelemetryInitializerPlugin2() {
    var _this = _super.call(this) || this;
    _this.identifier = "TelemetryInitializerPlugin";
    _this.priority = 199;
    var _id;
    var _initializers;
    _initDefaults();
    dynamicProto(TelemetryInitializerPlugin2, _this, function(_self, _base) {
      _self.addTelemetryInitializer = function(telemetryInitializer) {
        var theInitializer = {
          id: _id++,
          fn: telemetryInitializer
        };
        _initializers[_DYN_PUSH](theInitializer);
        var handler = {
          remove: function() {
            arrForEach(_initializers, function(initializer, idx) {
              if (initializer.id === theInitializer.id) {
                _initializers[_DYN_SPLICE](idx, 1);
                return -1;
              }
            });
          }
        };
        return handler;
      };
      _self[STR_PROCESS_TELEMETRY] = function(item, itemCtx) {
        var doNotSendItem = false;
        var telemetryInitializersCount = _initializers[_DYN_LENGTH];
        for (var i = 0; i < telemetryInitializersCount; ++i) {
          var telemetryInitializer = _initializers[i];
          if (telemetryInitializer) {
            try {
              if (telemetryInitializer.fn[_DYN_APPLY](null, [item]) === false) {
                doNotSendItem = true;
                break;
              }
            } catch (e) {
              _throwInternal(itemCtx[_DYN_DIAG_LOG](), 1, 64, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj(e) }, true);
            }
          }
        }
        if (!doNotSendItem) {
          _self[_DYN_PROCESS_NEXT](item, itemCtx);
        }
      };
      _self[_DYN__DO_TEARDOWN] = function() {
        _initDefaults();
      };
    });
    function _initDefaults() {
      _id = 0;
      _initializers = [];
    }
    return _this;
  }
  TelemetryInitializerPlugin2.__ieDyn = 1;
  return TelemetryInitializerPlugin2;
}(BaseTelemetryPlugin);

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/BaseCore.js
var strValidationError = "Plugins must provide initialize method";
var strNotificationManager = "_notificationManager";
var strSdkUnloadingError = "SDK is still unloading...";
var strSdkNotInitialized = "SDK is not initialized";
var defaultInitConfig = {
  loggingLevelConsole: 1
};
function _createPerfManager(core, notificationMgr) {
  return new PerfManager(notificationMgr);
}
function _validateExtensions(logger, channelPriority, allExtensions) {
  var _a3;
  var coreExtensions = [];
  var extPriorities = {};
  arrForEach(allExtensions, function(ext) {
    if (isNullOrUndefined(ext) || isNullOrUndefined(ext[_DYN_INITIALIZE])) {
      throwError(strValidationError);
    }
    var extPriority = ext[STR_PRIORITY];
    var identifier = ext[_DYN_IDENTIFIER];
    if (ext && extPriority) {
      if (!isNullOrUndefined(extPriorities[extPriority])) {
        _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
      } else {
        extPriorities[extPriority] = identifier;
      }
    }
    if (!extPriority || extPriority < channelPriority) {
      coreExtensions[_DYN_PUSH](ext);
    }
  });
  return _a3 = {
    all: allExtensions
  }, _a3[STR_CORE] = coreExtensions, _a3;
}
function _isPluginPresent(thePlugin, plugins) {
  var exists = false;
  arrForEach(plugins, function(plugin) {
    if (plugin === thePlugin) {
      exists = true;
      return -1;
    }
  });
  return exists;
}
function _createDummyNotificationManager() {
  var _a3;
  return objCreateFn((_a3 = {}, _a3[_DYN_ADD_NOTIFICATION_LIS1] = function(listener) {
  }, _a3[_DYN_REMOVE_NOTIFICATION_2] = function(listener) {
  }, _a3[STR_EVENTS_SENT] = function(events) {
  }, _a3[STR_EVENTS_DISCARDED] = function(events, reason) {
  }, _a3[STR_EVENTS_SEND_REQUEST] = function(sendReason, isAsync) {
  }, _a3));
}
var BaseCore = function() {
  function BaseCore2() {
    var _config;
    var _isInitialized;
    var _eventQueue;
    var _notificationManager;
    var _perfManager;
    var _cfgPerfManager;
    var _cookieManager;
    var _pluginChain;
    var _configExtensions;
    var _coreExtensions;
    var _channelControl;
    var _channelConfig;
    var _channelQueue;
    var _isUnloading;
    var _telemetryInitializerPlugin;
    var _internalLogsEventName;
    var _evtNamespace;
    var _unloadHandlers;
    var _debugListener2;
    var _traceCtx;
    var _internalLogPoller = 0;
    dynamicProto(BaseCore2, this, function(_self) {
      _initDefaults();
      _self[_DYN_IS_INITIALIZED] = function() {
        return _isInitialized;
      };
      _self[_DYN_INITIALIZE] = function(config, extensions, logger, notificationManager) {
        if (_isUnloading) {
          throwError(strSdkUnloadingError);
        }
        if (_self[_DYN_IS_INITIALIZED]()) {
          throwError("Core should not be initialized more than once");
        }
        _config = config || {};
        _self[_DYN_CONFIG] = _config;
        if (isNullOrUndefined(config[_DYN_INSTRUMENTATION_KEY])) {
          throwError("Please provide instrumentation key");
        }
        _notificationManager = notificationManager;
        _self[strNotificationManager] = notificationManager;
        _initDebugListener();
        _initPerfManager();
        _initExtConfig();
        if (logger) {
          _self[_DYN_LOGGER] = logger;
        }
        var cfgExtensions = getSetValue(_config, STR_EXTENSIONS, []);
        _configExtensions = [];
        _configExtensions[_DYN_PUSH].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions, false));
        _channelConfig = getSetValue(_config, STR_CHANNELS, []);
        _initPluginChain(null);
        if (!_channelQueue || _channelQueue[_DYN_LENGTH] === 0) {
          throwError("No " + STR_CHANNELS + " available");
        }
        _isInitialized = true;
        _self.releaseQueue();
      };
      _self.getTransmissionControls = function() {
        var controls = [];
        if (_channelQueue) {
          arrForEach(_channelQueue, function(channels) {
            controls[_DYN_PUSH](channels.queue);
          });
        }
        return objFreeze(controls);
      };
      _self.track = function(telemetryItem) {
        telemetryItem.iKey = telemetryItem.iKey || _config[_DYN_INSTRUMENTATION_KEY];
        telemetryItem[_DYN_TIME] = telemetryItem[_DYN_TIME] || toISOString(new Date());
        telemetryItem.ver = telemetryItem.ver || "4.0";
        if (!_isUnloading && _self[_DYN_IS_INITIALIZED]()) {
          _createTelCtx()[_DYN_PROCESS_NEXT](telemetryItem);
        } else {
          _eventQueue[_DYN_PUSH](telemetryItem);
        }
      };
      _self[_DYN_GET_PROCESS_TEL_CONT0] = _createTelCtx;
      _self[_DYN_GET_NOTIFY_MGR] = function() {
        if (!_notificationManager) {
          _notificationManager = _createDummyNotificationManager();
          _self[strNotificationManager] = _notificationManager;
        }
        return _notificationManager;
      };
      _self[_DYN_ADD_NOTIFICATION_LIS1] = function(listener) {
        if (_notificationManager) {
          _notificationManager[_DYN_ADD_NOTIFICATION_LIS1](listener);
        }
      };
      _self[_DYN_REMOVE_NOTIFICATION_2] = function(listener) {
        if (_notificationManager) {
          _notificationManager[_DYN_REMOVE_NOTIFICATION_2](listener);
        }
      };
      _self.getCookieMgr = function() {
        if (!_cookieManager) {
          _cookieManager = createCookieMgr(_config, _self[_DYN_LOGGER]);
        }
        return _cookieManager;
      };
      _self.setCookieMgr = function(cookieMgr) {
        _cookieManager = cookieMgr;
      };
      _self[STR_GET_PERF_MGR] = function() {
        if (!_perfManager && !_cfgPerfManager) {
          if (getCfgValue(_config.enablePerfMgr)) {
            var createPerfMgr = getCfgValue(_config[STR_CREATE_PERF_MGR]);
            if (isFunction(createPerfMgr)) {
              _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR]());
            }
          }
        }
        return _perfManager || _cfgPerfManager || getGblPerfMgr();
      };
      _self.setPerfMgr = function(perfMgr) {
        _perfManager = perfMgr;
      };
      _self.eventCnt = function() {
        return _eventQueue[_DYN_LENGTH];
      };
      _self.releaseQueue = function() {
        if (_isInitialized && _eventQueue[_DYN_LENGTH] > 0) {
          var eventQueue = _eventQueue;
          _eventQueue = [];
          arrForEach(eventQueue, function(event) {
            _createTelCtx()[_DYN_PROCESS_NEXT](event);
          });
        }
      };
      _self.pollInternalLogs = function(eventName) {
        _internalLogsEventName = eventName || null;
        var interval = getCfgValue(_config.diagnosticLogInterval);
        if (!interval || !(interval > 0)) {
          interval = 1e4;
        }
        if (_internalLogPoller) {
          clearInterval(_internalLogPoller);
        }
        _internalLogPoller = setInterval(function() {
          _flushInternalLogs();
        }, interval);
        return _internalLogPoller;
      };
      _self[_DYN_STOP_POLLING_INTERNA3] = function() {
        if (_internalLogPoller) {
          clearInterval(_internalLogPoller);
          _internalLogPoller = 0;
          _flushInternalLogs();
        }
      };
      proxyFunctions(_self, function() {
        return _telemetryInitializerPlugin;
      }, ["addTelemetryInitializer"]);
      _self.unload = function(isAsync, unloadComplete, cbTimeout) {
        var _a3;
        if (isAsync === void 0) {
          isAsync = true;
        }
        if (!_isInitialized) {
          throwError(strSdkNotInitialized);
        }
        if (_isUnloading) {
          throwError(strSdkUnloadingError);
        }
        var unloadState = (_a3 = {
          reason: 50
        }, _a3[_DYN_IS_ASYNC] = isAsync, _a3.flushComplete = false, _a3);
        var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
        processUnloadCtx[_DYN_ON_COMPLETE](function() {
          _initDefaults();
          unloadComplete && unloadComplete(unloadState);
        }, _self);
        function _doUnload(flushComplete) {
          unloadState.flushComplete = flushComplete;
          _isUnloading = true;
          _unloadHandlers.run(processUnloadCtx, unloadState);
          _self[_DYN_STOP_POLLING_INTERNA3]();
          processUnloadCtx[_DYN_PROCESS_NEXT](unloadState);
        }
        if (!_flushChannels(isAsync, _doUnload, 6, cbTimeout)) {
          _doUnload(false);
        }
      };
      _self[_DYN_GET_PLUGIN] = _getPlugin;
      _self.addPlugin = function(plugin, replaceExisting, isAsync, addCb) {
        if (!plugin) {
          addCb && addCb(false);
          _logOrThrowError(strValidationError);
          return;
        }
        var existingPlugin = _getPlugin(plugin[_DYN_IDENTIFIER]);
        if (existingPlugin && !replaceExisting) {
          addCb && addCb(false);
          _logOrThrowError("Plugin [" + plugin[_DYN_IDENTIFIER] + "] is already loaded!");
          return;
        }
        var updateState = {
          reason: 16
        };
        function _addPlugin(removed) {
          _configExtensions[_DYN_PUSH](plugin);
          updateState.added = [plugin];
          _initPluginChain(updateState);
          addCb && addCb(true);
        }
        if (existingPlugin) {
          var removedPlugins_1 = [existingPlugin.plugin];
          var unloadState = {
            reason: 2,
            isAsync: !!isAsync
          };
          _removePlugins(removedPlugins_1, unloadState, function(removed) {
            if (!removed) {
              addCb && addCb(false);
            } else {
              updateState.removed = removedPlugins_1;
              updateState.reason |= 32;
              _addPlugin(true);
            }
          });
        } else {
          _addPlugin(false);
        }
      };
      _self.evtNamespace = function() {
        return _evtNamespace;
      };
      _self[_DYN_FLUSH] = _flushChannels;
      _self.getTraceCtx = function(createNew) {
        if (!_traceCtx) {
          _traceCtx = createDistributedTraceContext();
        }
        return _traceCtx;
      };
      _self.setTraceCtx = function(traceCtx) {
        _traceCtx = traceCtx || null;
      };
      proxyFunctionAs(_self, "addUnloadCb", function() {
        return _unloadHandlers;
      }, "add");
      function _initDefaults() {
        _isInitialized = false;
        _config = objExtend(true, {}, defaultInitConfig);
        _self[_DYN_CONFIG] = _config;
        _self[_DYN_LOGGER] = new DiagnosticLogger(_config);
        _self[_DYN__EXTENSIONS] = [];
        _telemetryInitializerPlugin = new TelemetryInitializerPlugin();
        _eventQueue = [];
        _notificationManager = null;
        _perfManager = null;
        _cfgPerfManager = null;
        _cookieManager = null;
        _pluginChain = null;
        _coreExtensions = null;
        _configExtensions = [];
        _channelControl = null;
        _channelConfig = null;
        _channelQueue = null;
        _isUnloading = false;
        _internalLogsEventName = null;
        _evtNamespace = createUniqueNamespace("AIBaseCore", true);
        _unloadHandlers = createUnloadHandlerContainer();
        _traceCtx = null;
      }
      function _createTelCtx() {
        return createProcessTelemetryContext(_getPluginChain(), _config, _self);
      }
      function _initPluginChain(updateState) {
        var theExtensions = _validateExtensions(_self[_DYN_LOGGER], ChannelControllerPriority, _configExtensions);
        _coreExtensions = theExtensions[STR_CORE];
        _pluginChain = null;
        var allExtensions = theExtensions.all;
        _channelQueue = objFreeze(createChannelQueues(_channelConfig, allExtensions, _self));
        if (_channelControl) {
          var idx = arrIndexOf(allExtensions, _channelControl);
          if (idx !== -1) {
            allExtensions[_DYN_SPLICE](idx, 1);
          }
          idx = arrIndexOf(_coreExtensions, _channelControl);
          if (idx !== -1) {
            _coreExtensions[_DYN_SPLICE](idx, 1);
          }
          _channelControl._setQueue(_channelQueue);
        } else {
          _channelControl = createChannelControllerPlugin(_channelQueue, _self);
        }
        allExtensions[_DYN_PUSH](_channelControl);
        _coreExtensions[_DYN_PUSH](_channelControl);
        _self[_DYN__EXTENSIONS] = sortPlugins(allExtensions);
        _channelControl[_DYN_INITIALIZE](_config, _self, allExtensions);
        initializePlugins(_createTelCtx(), allExtensions);
        _self[_DYN__EXTENSIONS] = objFreeze(sortPlugins(_coreExtensions || [])).slice();
        if (updateState) {
          _doUpdate(updateState);
        }
      }
      function _getPlugin(pluginIdentifier) {
        var _a3;
        var theExt = null;
        var thePlugin = null;
        arrForEach(_self[_DYN__EXTENSIONS], function(ext) {
          if (ext[_DYN_IDENTIFIER] === pluginIdentifier && ext !== _channelControl && ext !== _telemetryInitializerPlugin) {
            thePlugin = ext;
            return -1;
          }
        });
        if (!thePlugin && _channelControl) {
          thePlugin = _channelControl.getChannel(pluginIdentifier);
        }
        if (thePlugin) {
          theExt = (_a3 = {
            plugin: thePlugin
          }, _a3[_DYN_SET_ENABLED] = function(enabled) {
            _getPluginState(thePlugin)[STR_DISABLED] = !enabled;
          }, _a3.isEnabled = function() {
            var pluginState = _getPluginState(thePlugin);
            return !pluginState[_DYN_TEARDOWN] && !pluginState[STR_DISABLED];
          }, _a3.remove = function(isAsync, removeCb) {
            var _a4;
            if (isAsync === void 0) {
              isAsync = true;
            }
            var pluginsToRemove = [thePlugin];
            var unloadState = (_a4 = {
              reason: 1
            }, _a4[_DYN_IS_ASYNC] = isAsync, _a4);
            _removePlugins(pluginsToRemove, unloadState, function(removed) {
              if (removed) {
                _initPluginChain({
                  reason: 32,
                  removed: pluginsToRemove
                });
              }
              removeCb && removeCb(removed);
            });
          }, _a3);
        }
        return theExt;
      }
      function _getPluginChain() {
        if (!_pluginChain) {
          var extensions = (_coreExtensions || []).slice();
          if (arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) {
            extensions[_DYN_PUSH](_telemetryInitializerPlugin);
          }
          _pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _config, _self);
        }
        return _pluginChain;
      }
      function _removePlugins(thePlugins, unloadState, removeComplete) {
        if (thePlugins && thePlugins[_DYN_LENGTH] > 0) {
          var unloadChain = createTelemetryProxyChain(thePlugins, _config, _self);
          var unloadCtx = createProcessTelemetryUnloadContext(unloadChain, _self);
          unloadCtx[_DYN_ON_COMPLETE](function() {
            var removed = false;
            var newConfigExtensions = [];
            arrForEach(_configExtensions, function(plugin, idx) {
              if (!_isPluginPresent(plugin, thePlugins)) {
                newConfigExtensions[_DYN_PUSH](plugin);
              } else {
                removed = true;
              }
            });
            _configExtensions = newConfigExtensions;
            var newChannelConfig = [];
            if (_channelConfig) {
              arrForEach(_channelConfig, function(queue, idx) {
                var newQueue = [];
                arrForEach(queue, function(channel) {
                  if (!_isPluginPresent(channel, thePlugins)) {
                    newQueue[_DYN_PUSH](channel);
                  } else {
                    removed = true;
                  }
                });
                newChannelConfig[_DYN_PUSH](newQueue);
              });
              _channelConfig = newChannelConfig;
            }
            removeComplete && removeComplete(removed);
          });
          unloadCtx[_DYN_PROCESS_NEXT](unloadState);
        } else {
          removeComplete(false);
        }
      }
      function _flushInternalLogs() {
        var queue = _self[_DYN_LOGGER] ? _self[_DYN_LOGGER].queue : [];
        if (queue) {
          arrForEach(queue, function(logMessage) {
            var _a3;
            var item = (_a3 = {}, _a3[_DYN_NAME] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID], _a3.iKey = getCfgValue(_config[_DYN_INSTRUMENTATION_KEY]), _a3.time = toISOString(new Date()), _a3.baseType = _InternalLogMessage.dataType, _a3.baseData = { message: logMessage[_DYN_MESSAGE] }, _a3);
            _self.track(item);
          });
          queue[_DYN_LENGTH] = 0;
        }
      }
      function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
        if (_channelControl) {
          return _channelControl[_DYN_FLUSH](isAsync, callBack, sendReason || 6, cbTimeout);
        }
        callBack && callBack(false);
        return true;
      }
      function _initDebugListener() {
        var disableDbgExt = getCfgValue(_config.disableDbgExt);
        if (disableDbgExt === true && _debugListener2) {
          _notificationManager[_DYN_REMOVE_NOTIFICATION_2](_debugListener2);
          _debugListener2 = null;
        }
        if (_notificationManager && !_debugListener2 && disableDbgExt !== true) {
          _debugListener2 = getDebugListener(_config);
          _notificationManager[_DYN_ADD_NOTIFICATION_LIS1](_debugListener2);
        }
      }
      function _initPerfManager() {
        var enablePerfMgr = getCfgValue(_config.enablePerfMgr);
        if (!enablePerfMgr && _cfgPerfManager) {
          _cfgPerfManager = null;
        }
        if (enablePerfMgr) {
          getSetValue(_config, STR_CREATE_PERF_MGR, _createPerfManager);
        }
      }
      function _initExtConfig() {
        var extConfig = getSetValue(_config, STR_EXTENSION_CONFIG, {});
        extConfig.NotificationManager = _notificationManager;
      }
      function _doUpdate(updateState) {
        var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
        if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) {
          updateCtx[_DYN_PROCESS_NEXT](updateState);
        }
      }
      function _logOrThrowError(message) {
        var logger = _self[_DYN_LOGGER];
        if (logger) {
          _throwInternal(logger, 2, 73, message);
        } else {
          throwError(message);
        }
      }
    });
  }
  BaseCore2.__ieDyn = 1;
  return BaseCore2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/NotificationManager.js
function _runListeners(listeners, name, isAsync, callback) {
  arrForEach(listeners, function(listener) {
    if (listener && listener[name]) {
      if (isAsync) {
        setTimeout(function() {
          return callback(listener);
        }, 0);
      } else {
        try {
          callback(listener);
        } catch (e) {
        }
      }
    }
  });
}
var NotificationManager = function() {
  function NotificationManager2(config) {
    this.listeners = [];
    var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
    dynamicProto(NotificationManager2, this, function(_self) {
      _self[_DYN_ADD_NOTIFICATION_LIS1] = function(listener) {
        _self.listeners[_DYN_PUSH](listener);
      };
      _self[_DYN_REMOVE_NOTIFICATION_2] = function(listener) {
        var index = arrIndexOf(_self[_DYN_LISTENERS], listener);
        while (index > -1) {
          _self.listeners[_DYN_SPLICE](index, 1);
          index = arrIndexOf(_self[_DYN_LISTENERS], listener);
        }
      };
      _self[STR_EVENTS_SENT] = function(events) {
        _runListeners(_self[_DYN_LISTENERS], STR_EVENTS_SENT, true, function(listener) {
          listener[STR_EVENTS_SENT](events);
        });
      };
      _self[STR_EVENTS_DISCARDED] = function(events, reason) {
        _runListeners(_self[_DYN_LISTENERS], STR_EVENTS_DISCARDED, true, function(listener) {
          listener[STR_EVENTS_DISCARDED](events, reason);
        });
      };
      _self[STR_EVENTS_SEND_REQUEST] = function(sendReason, isAsync) {
        _runListeners(_self[_DYN_LISTENERS], STR_EVENTS_SEND_REQUEST, isAsync, function(listener) {
          listener[STR_EVENTS_SEND_REQUEST](sendReason, isAsync);
        });
      };
      _self[STR_PERF_EVENT] = function(perfEvent) {
        if (perfEvent) {
          if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT]()) {
            _runListeners(_self[_DYN_LISTENERS], STR_PERF_EVENT, false, function(listener) {
              if (perfEvent[_DYN_IS_ASYNC]) {
                setTimeout(function() {
                  return listener[STR_PERF_EVENT](perfEvent);
                }, 0);
              } else {
                listener[STR_PERF_EVENT](perfEvent);
              }
            });
          }
        }
      };
    });
  }
  NotificationManager2.__ieDyn = 1;
  return NotificationManager2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/AppInsightsCore.js
var AppInsightsCore = function(_super) {
  __extendsFn(AppInsightsCore2, _super);
  function AppInsightsCore2() {
    var _this = _super.call(this) || this;
    dynamicProto(AppInsightsCore2, _this, function(_self, _base) {
      _self[_DYN_INITIALIZE] = function(config, extensions, logger, notificationManager) {
        _base[_DYN_INITIALIZE](config, extensions, logger || new DiagnosticLogger(config), notificationManager || new NotificationManager(config));
      };
      _self.track = function(telemetryItem) {
        doPerf(_self[STR_GET_PERF_MGR](), function() {
          return "AppInsightsCore:track";
        }, function() {
          if (telemetryItem === null) {
            _notifyInvalidEvent(telemetryItem);
            throwError("Invalid telemetry item");
          }
          _validateTelemetryItem(telemetryItem);
          _base.track(telemetryItem);
        }, function() {
          return { item: telemetryItem };
        }, !telemetryItem.sync);
      };
      function _validateTelemetryItem(telemetryItem) {
        if (isNullOrUndefined(telemetryItem[_DYN_NAME])) {
          _notifyInvalidEvent(telemetryItem);
          throwError("telemetry name required");
        }
      }
      function _notifyInvalidEvent(telemetryItem) {
        var manager = _self[_DYN_GET_NOTIFY_MGR]();
        if (manager) {
          manager[STR_EVENTS_DISCARDED]([telemetryItem], 2);
        }
      }
    });
    return _this;
  }
  AppInsightsCore2.__ieDyn = 1;
  return AppInsightsCore2;
}(BaseCore);

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK.Enums/EnumHelperFuncs.js
function createEnumStyle(values) {
  var enumClass = {};
  objForEachKey(values, function(field, value) {
    enumClass[field] = value;
    enumClass[value] = field;
  });
  return deepFreeze(enumClass);
}
function createValueMap(values) {
  var mapClass = {};
  objForEachKey(values, function(field, value) {
    mapClass[field] = value[1];
    mapClass[value[0]] = value[1];
  });
  return deepFreeze(mapClass);
}

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK.Enums/LoggingEnums.js
var _a;
var FAILED = "Failed";
var FAILED_MONITOR_AJAX = FAILED + "MonitorAjax";
var TRACK = "Track";
var START = "Start";
var STOP = "Stop";
var EVENT = "Event";
var AUTH_CONTEXT = "AuthContext";
var EXCEPTION = "Exception";
var LOCAL = "Local";
var SESSION = "Session";
var STORAGE = "Storage";
var BROWSER = "Browser";
var CANNOT = "Cannot";
var BUFFER = "Buffer";
var INSTRUMENTATION_KEY = "InstrumentationKey";
var LoggingSeverity = createEnumStyle({
  CRITICAL: 1,
  WARNING: 2
});
var _InternalMessageId = createEnumStyle((_a = {}, _a[BROWSER + "DoesNotSupport" + LOCAL + STORAGE] = 0, _a[BROWSER + CANNOT + "Read" + LOCAL + STORAGE] = 1, _a[BROWSER + CANNOT + "Read" + SESSION + STORAGE] = 2, _a[BROWSER + CANNOT + "Write" + LOCAL + STORAGE] = 3, _a[BROWSER + CANNOT + "Write" + SESSION + STORAGE] = 4, _a[BROWSER + FAILED + "RemovalFrom" + LOCAL + STORAGE] = 5, _a[BROWSER + FAILED + "RemovalFrom" + SESSION + STORAGE] = 6, _a[CANNOT + "SendEmptyTelemetry"] = 7, _a.ClientPerformanceMathError = 8, _a["ErrorParsingAI" + SESSION + "Cookie"] = 9, _a.ErrorPVCalc = 10, _a[EXCEPTION + "WhileLoggingError"] = 11, _a[FAILED + "AddingTelemetryTo" + BUFFER] = 12, _a[FAILED_MONITOR_AJAX + "Abort"] = 13, _a[FAILED_MONITOR_AJAX + "Dur"] = 14, _a[FAILED_MONITOR_AJAX + "Open"] = 15, _a[FAILED_MONITOR_AJAX + "RSC"] = 16, _a[FAILED_MONITOR_AJAX + "Send"] = 17, _a[FAILED_MONITOR_AJAX + "GetCorrelationHeader"] = 18, _a[FAILED + "ToAddHandlerForOnBeforeUnload"] = 19, _a[FAILED + "ToSendQueuedTelemetry"] = 20, _a[FAILED + "ToReportDataLoss"] = 21, _a["Flush" + FAILED] = 22, _a.MessageLimitPerPVExceeded = 23, _a.MissingRequiredFieldSpecification = 24, _a.NavigationTimingNotSupported = 25, _a.OnError = 26, _a[SESSION + "RenewalDateIsZero"] = 27, _a.SenderNotInitialized = 28, _a[START + TRACK + EVENT + FAILED] = 29, _a[STOP + TRACK + EVENT + FAILED] = 30, _a[START + TRACK + FAILED] = 31, _a[STOP + TRACK + FAILED] = 32, _a.TelemetrySampledAndNotSent = 33, _a[TRACK + EVENT + FAILED] = 34, _a[TRACK + EXCEPTION + FAILED] = 35, _a[TRACK + "Metric" + FAILED] = 36, _a[TRACK + "PV" + FAILED] = 37, _a[TRACK + "PV" + FAILED + "Calc"] = 38, _a[TRACK + "Trace" + FAILED] = 39, _a["Transmission" + FAILED] = 40, _a[FAILED + "ToSet" + STORAGE + BUFFER] = 41, _a[FAILED + "ToRestore" + STORAGE + BUFFER] = 42, _a.InvalidBackendResponse = 43, _a[FAILED + "ToFixDepricatedValues"] = 44, _a.InvalidDurationValue = 45, _a.TelemetryEnvelopeInvalid = 46, _a.CreateEnvelopeError = 47, _a[CANNOT + "SerializeObject"] = 48, _a[CANNOT + "SerializeObjectNonSerializable"] = 49, _a.CircularReferenceDetected = 50, _a["Clear" + AUTH_CONTEXT + FAILED] = 51, _a[EXCEPTION + "Truncated"] = 52, _a.IllegalCharsInName = 53, _a.ItemNotInArray = 54, _a.MaxAjaxPerPVExceeded = 55, _a.MessageTruncated = 56, _a.NameTooLong = 57, _a.SampleRateOutOfRange = 58, _a["Set" + AUTH_CONTEXT + FAILED] = 59, _a["Set" + AUTH_CONTEXT + FAILED + "AccountName"] = 60, _a.StringValueTooLong = 61, _a.StartCalledMoreThanOnce = 62, _a.StopCalledWithoutStart = 63, _a["TelemetryInitializer" + FAILED] = 64, _a.TrackArgumentsNotSpecified = 65, _a.UrlTooLong = 66, _a[SESSION + STORAGE + BUFFER + "Full"] = 67, _a[CANNOT + "AccessCookie"] = 68, _a.IdTooLong = 69, _a.InvalidEvent = 70, _a[FAILED_MONITOR_AJAX + "SetRequestHeader"] = 71, _a["Send" + BROWSER + "InfoOnUserInit"] = 72, _a["Plugin" + EXCEPTION] = 73, _a["Notification" + EXCEPTION] = 74, _a.SnippetScriptLoadFailure = 99, _a["Invalid" + INSTRUMENTATION_KEY] = 100, _a[CANNOT + "ParseAiBlobValue"] = 101, _a.InvalidContentBlob = 102, _a[TRACK + "PageAction" + EVENT + FAILED] = 103, _a[FAILED + "AddingCustomDefinedRequestContext"] = 104, _a["InMemory" + STORAGE + BUFFER + "Full"] = 105, _a[INSTRUMENTATION_KEY + "Deprecation"] = 106, _a));

// node_modules/.pnpm/@microsoft+applicationinsights-core-js@2.8.8/node_modules/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/InstrumentHooks.js
var aiInstrumentHooks = "_aiHooks";
var cbNames = [
  "req",
  "rsp",
  "hkErr",
  "fnErr"
];
function _arrLoop(arr, fn) {
  if (arr) {
    for (var lp = 0; lp < arr[_DYN_LENGTH]; lp++) {
      if (fn(arr[lp], lp)) {
        break;
      }
    }
  }
}
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
  if (type >= 0 && type <= 2) {
    _arrLoop(hooks, function(hook, idx) {
      var cbks = hook.cbks;
      var cb = cbks[cbNames[type]];
      if (cb) {
        callDetails.ctx = function() {
          var ctx = hookCtx[idx] = hookCtx[idx] || {};
          return ctx;
        };
        try {
          cb[_DYN_APPLY](callDetails.inst, cbArgs);
        } catch (err) {
          var orgEx = callDetails.err;
          try {
            var hookErrorCb = cbks[cbNames[2]];
            if (hookErrorCb) {
              callDetails.err = err;
              hookErrorCb[_DYN_APPLY](callDetails.inst, cbArgs);
            }
          } catch (e) {
          } finally {
            callDetails.err = orgEx;
          }
        }
      }
    });
  }
}
function _createFunctionHook(aiHook) {
  return function() {
    var _a3;
    var funcThis = this;
    var orgArgs = arguments;
    var hooks = aiHook.h;
    var funcArgs = (_a3 = {}, _a3[_DYN_NAME] = aiHook.n, _a3.inst = funcThis, _a3.ctx = null, _a3.set = _replaceArg, _a3);
    var hookCtx = [];
    var cbArgs = _createArgs([funcArgs], orgArgs);
    funcArgs.evt = getGlobalInst("event");
    function _createArgs(target, theArgs) {
      _arrLoop(theArgs, function(arg) {
        target[_DYN_PUSH](arg);
      });
      return target;
    }
    function _replaceArg(idx, value) {
      orgArgs = _createArgs([], orgArgs);
      orgArgs[idx] = value;
      cbArgs = _createArgs([funcArgs], orgArgs);
    }
    _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0);
    var theFunc = aiHook.f;
    if (theFunc) {
      try {
        funcArgs.rslt = theFunc[_DYN_APPLY](funcThis, orgArgs);
      } catch (err) {
        funcArgs.err = err;
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3);
        throw err;
      }
    }
    _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1);
    return funcArgs.rslt;
  };
}
function _getOwner(target, name, checkPrototype) {
  var owner = null;
  if (target) {
    if (hasOwnProperty(target, name)) {
      owner = target;
    } else if (checkPrototype) {
      owner = _getOwner(_getObjProto2(target), name, false);
    }
  }
  return owner;
}
function InstrumentProto(target, funcName, callbacks) {
  if (target) {
    return InstrumentFunc(target[strShimPrototype], funcName, callbacks, false);
  }
  return null;
}
function _createInstrumentHook(owner, funcName, fn, callbacks) {
  var aiHook = fn && fn[aiInstrumentHooks];
  if (!aiHook) {
    aiHook = {
      i: 0,
      n: funcName,
      f: fn,
      h: []
    };
    var newFunc = _createFunctionHook(aiHook);
    newFunc[aiInstrumentHooks] = aiHook;
    owner[funcName] = newFunc;
  }
  var theHook = {
    id: aiHook.i,
    cbks: callbacks,
    rm: function() {
      var id = this.id;
      _arrLoop(aiHook.h, function(hook, idx) {
        if (hook.id === id) {
          aiHook.h[_DYN_SPLICE](idx, 1);
          return 1;
        }
      });
    }
  };
  aiHook.i++;
  aiHook.h[_DYN_PUSH](theHook);
  return theHook;
}
function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
  if (checkPrototype === void 0) {
    checkPrototype = true;
  }
  if (target && funcName && callbacks) {
    var owner = _getOwner(target, funcName, checkPrototype);
    if (owner) {
      var fn = owner[funcName];
      if (typeof fn === strShimFunction) {
        return _createInstrumentHook(owner, funcName, fn, callbacks);
      }
    }
  }
  return null;
}
function InstrumentEvent(target, evtName, callbacks, checkPrototype) {
  if (target && evtName && callbacks) {
    var owner = _getOwner(target, evtName, checkPrototype) || target;
    if (owner) {
      return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
    }
  }
  return null;
}

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Enums.js
var StorageType = createEnumStyle({
  LocalStorage: 0,
  SessionStorage: 1
});
var DistributedTracingModes = createEnumStyle({
  AI: 0,
  AI_AND_W3C: 1,
  W3C: 2
});

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Constants.js
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var DEFAULT_BREEZE_PATH = "/v2/track";
var strNotSpecified = "not_specified";
var strIkey = "iKey";

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/DomHelperFuncs.js
function createDomEvent(eventName) {
  var event = null;
  if (isFunction(Event)) {
    event = new Event(eventName);
  } else {
    var doc = getDocument();
    if (doc && doc.createEvent) {
      event = doc.createEvent("Event");
      event.initEvent(eventName, true, true);
    }
  }
  return event;
}

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/__DynamicConstants.js
var _DYN_SPLIT2 = "split";
var _DYN_LENGTH2 = "length";
var _DYN_TO_LOWER_CASE2 = "toLowerCase";
var _DYN_INGESTIONENDPOINT = "ingestionendpoint";
var _DYN_TO_STRING = "toString";
var _DYN_REMOVE_ITEM = "removeItem";
var _DYN_NAME2 = "name";
var _DYN_PATHNAME = "pathname";
var _DYN_CORRELATION_HEADER_E0 = "correlationHeaderExcludePatterns";
var _DYN_INDEX_OF2 = "indexOf";
var _DYN_EXTENSION_CONFIG = "extensionConfig";
var _DYN_EXCEPTIONS = "exceptions";
var _DYN_PARSED_STACK = "parsedStack";
var _DYN_PROPERTIES = "properties";
var _DYN_MEASUREMENTS = "measurements";
var _DYN_STRINGIFY = "stringify";
var _DYN_MESSAGE2 = "message";
var _DYN_SIZE_IN_BYTES = "sizeInBytes";
var _DYN_TYPE_NAME = "typeName";
var _DYN_SEVERITY_LEVEL = "severityLevel";
var _DYN_PROBLEM_GROUP = "problemGroup";
var _DYN_IS_MANUAL = "isManual";
var _DYN__CREATE_FROM_INTERFA1 = "CreateFromInterface";
var _DYN_HAS_FULL_STACK = "hasFullStack";
var _DYN_LEVEL = "level";
var _DYN_METHOD = "method";
var _DYN_ASSEMBLY = "assembly";
var _DYN_FILE_NAME = "fileName";
var _DYN_LINE = "line";
var _DYN_DURATION = "duration";
var _DYN_RECEIVED_RESPONSE = "receivedResponse";
var _DYN_SUBSTRING2 = "substring";
var _DYN_SANITIZE_KEY_AND_ADD2 = "sanitizeKeyAndAddUniqueness";
var _DYN_SANITIZE_EXCEPTION = "sanitizeException";
var _DYN_SANITIZE_PROPERTIES = "sanitizeProperties";
var _DYN_SANITIZE_MEASUREMENT3 = "sanitizeMeasurements";

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/HelperFuncs.js
var strEmpty = "";
function stringToBoolOrDefault(str, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }
  if (str === void 0 || str === null) {
    return defaultValue;
  }
  return str.toString()[_DYN_TO_LOWER_CASE2]() === "true";
}
function msToTimeSpan(totalms) {
  if (isNaN(totalms) || totalms < 0) {
    totalms = 0;
  }
  totalms = Math.round(totalms);
  var ms = strEmpty + totalms % 1e3;
  var sec = strEmpty + Math.floor(totalms / 1e3) % 60;
  var min = strEmpty + Math.floor(totalms / (1e3 * 60)) % 60;
  var hour = strEmpty + Math.floor(totalms / (1e3 * 60 * 60)) % 24;
  var days = Math.floor(totalms / (1e3 * 60 * 60 * 24));
  ms = ms[_DYN_LENGTH2] === 1 ? "00" + ms : ms[_DYN_LENGTH2] === 2 ? "0" + ms : ms;
  sec = sec[_DYN_LENGTH2] < 2 ? "0" + sec : sec;
  min = min[_DYN_LENGTH2] < 2 ? "0" + min : min;
  hour = hour[_DYN_LENGTH2] < 2 ? "0" + hour : hour;
  return (days > 0 ? days + "." : strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function getExtensionByName(extensions, identifier) {
  var extension = null;
  arrForEach(extensions, function(value) {
    if (value.identifier === identifier) {
      extension = value;
      return -1;
    }
  });
  return extension;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
  return !error && isString(message) && (message === "Script error." || message === "Script error");
}

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/RequestResponseHeaders.js
var RequestHeaders = createValueMap({
  requestContextHeader: [0, "Request-Context"],
  requestContextTargetKey: [1, "appId"],
  requestContextAppIdFormat: [2, "appId=cid-v1:"],
  requestIdHeader: [3, "Request-Id"],
  traceParentHeader: [4, "traceparent"],
  traceStateHeader: [5, "tracestate"],
  sdkContextHeader: [6, "Sdk-Context"],
  sdkContextHeaderAppIdRequest: [7, "appId"],
  requestContextHeaderLowerCase: [8, "request-context"]
});

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/StorageHelperFuncs.js
var _canUseLocalStorage = void 0;
var _canUseSessionStorage = void 0;
function _getLocalStorageObject() {
  if (utlCanUseLocalStorage()) {
    return _getVerifiedStorageObject(StorageType.LocalStorage);
  }
  return null;
}
function _getVerifiedStorageObject(storageType) {
  try {
    if (isNullOrUndefined(getGlobal())) {
      return null;
    }
    var uid = new Date()[_DYN_TO_STRING]();
    var storage = getGlobalInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
    storage.setItem(uid, uid);
    var fail = storage.getItem(uid) !== uid;
    storage[_DYN_REMOVE_ITEM](uid);
    if (!fail) {
      return storage;
    }
  } catch (exception) {
  }
  return null;
}
function _getSessionStorageObject() {
  if (utlCanUseSessionStorage()) {
    return _getVerifiedStorageObject(StorageType.SessionStorage);
  }
  return null;
}
function utlDisableStorage() {
  _canUseLocalStorage = false;
  _canUseSessionStorage = false;
}
function utlEnableStorage() {
  _canUseLocalStorage = utlCanUseLocalStorage(true);
  _canUseSessionStorage = utlCanUseSessionStorage(true);
}
function utlCanUseLocalStorage(reset) {
  if (reset || _canUseLocalStorage === void 0) {
    _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
  }
  return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      return storage.getItem(name);
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2, 1, "Browser failed read of local storage. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return null;
}
function utlSetLocalStorage(logger, name, data) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      storage.setItem(name, data);
      return true;
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2, 3, "Browser failed write to local storage. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return false;
}
function utlRemoveStorage(logger, name) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      storage[_DYN_REMOVE_ITEM](name);
      return true;
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2, 5, "Browser failed removal of local storage item. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return false;
}
function utlCanUseSessionStorage(reset) {
  if (reset || _canUseSessionStorage === void 0) {
    _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
  }
  return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
  var keys = [];
  if (utlCanUseSessionStorage()) {
    objForEachKey(getGlobalInst("sessionStorage"), function(key) {
      keys.push(key);
    });
  }
  return keys;
}
function utlGetSessionStorage(logger, name) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      return storage.getItem(name);
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2, 2, "Browser failed read of session storage. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return null;
}
function utlSetSessionStorage(logger, name, data) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      storage.setItem(name, data);
      return true;
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2, 4, "Browser failed write to session storage. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return false;
}
function utlRemoveSessionStorage(logger, name) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      storage[_DYN_REMOVE_ITEM](name);
      return true;
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2, 6, "Browser failed removal of session storage item. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return false;
}

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/DataSanitizer.js
var _a2;
function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
  var origLength = key[_DYN_LENGTH2];
  var field = dataSanitizeKey(logger, key);
  if (field[_DYN_LENGTH2] !== origLength) {
    var i = 0;
    var uniqueField = field;
    while (map[uniqueField] !== void 0) {
      i++;
      uniqueField = field[_DYN_SUBSTRING2](0, 150 - 3) + dsPadNumber(i);
    }
    field = uniqueField;
  }
  return field;
}
function dataSanitizeKey(logger, name) {
  var nameTrunc;
  if (name) {
    name = strTrim(name[_DYN_TO_STRING]());
    if (name[_DYN_LENGTH2] > 150) {
      nameTrunc = name[_DYN_SUBSTRING2](0, 150);
      _throwInternal(logger, 2, 57, "name is too long.  It has been truncated to " + 150 + " characters.", { name }, true);
    }
  }
  return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
  if (maxLength === void 0) {
    maxLength = 1024;
  }
  var valueTrunc;
  if (value) {
    maxLength = maxLength ? maxLength : 1024;
    value = strTrim(value);
    if (value.toString()[_DYN_LENGTH2] > maxLength) {
      valueTrunc = value[_DYN_TO_STRING]()[_DYN_SUBSTRING2](0, maxLength);
      _throwInternal(logger, 2, 61, "string value is too long. It has been truncated to " + maxLength + " characters.", { value }, true);
    }
  }
  return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
  return dataSanitizeInput(logger, url, 2048, 66);
}
function dataSanitizeMessage(logger, message) {
  var messageTrunc;
  if (message) {
    if (message[_DYN_LENGTH2] > 32768) {
      messageTrunc = message[_DYN_SUBSTRING2](0, 32768);
      _throwInternal(logger, 2, 56, "message is too long, it has been truncated to " + 32768 + " characters.", { message }, true);
    }
  }
  return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
  var exceptionTrunc;
  if (exception) {
    var value = "" + exception;
    if (value[_DYN_LENGTH2] > 32768) {
      exceptionTrunc = value[_DYN_SUBSTRING2](0, 32768);
      _throwInternal(logger, 2, 52, "exception is too long, it has been truncated to " + 32768 + " characters.", { exception }, true);
    }
  }
  return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
  if (properties) {
    var tempProps_1 = {};
    objForEachKey(properties, function(prop, value) {
      if (isObject(value) && hasJSON()) {
        try {
          value = getJSON()[_DYN_STRINGIFY](value);
        } catch (e) {
          _throwInternal(logger, 2, 49, "custom property is not valid", { exception: e }, true);
        }
      }
      value = dataSanitizeString(logger, value, 8192);
      prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
      tempProps_1[prop] = value;
    });
    properties = tempProps_1;
  }
  return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
  if (measurements) {
    var tempMeasurements_1 = {};
    objForEachKey(measurements, function(measure, value) {
      measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
      tempMeasurements_1[measure] = value;
    });
    measurements = tempMeasurements_1;
  }
  return measurements;
}
function dataSanitizeId(logger, id) {
  return id ? dataSanitizeInput(logger, id, 128, 69)[_DYN_TO_STRING]() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
  var inputTrunc;
  if (input) {
    input = strTrim(input);
    if (input[_DYN_LENGTH2] > maxLength) {
      inputTrunc = input[_DYN_SUBSTRING2](0, maxLength);
      _throwInternal(logger, 2, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
    }
  }
  return inputTrunc || input;
}
function dsPadNumber(num) {
  var s = "00" + num;
  return s.substr(s[_DYN_LENGTH2] - 3);
}
var DataSanitizer = (_a2 = {
  MAX_NAME_LENGTH: 150,
  MAX_ID_LENGTH: 128,
  MAX_PROPERTY_LENGTH: 8192,
  MAX_STRING_LENGTH: 1024,
  MAX_URL_LENGTH: 2048,
  MAX_MESSAGE_LENGTH: 32768,
  MAX_EXCEPTION_LENGTH: 32768
}, _a2[_DYN_SANITIZE_KEY_AND_ADD2] = dataSanitizeKeyAndAddUniqueness, _a2.sanitizeKey = dataSanitizeKey, _a2.sanitizeString = dataSanitizeString, _a2.sanitizeUrl = dataSanitizeUrl, _a2.sanitizeMessage = dataSanitizeMessage, _a2[_DYN_SANITIZE_EXCEPTION] = dataSanitizeException, _a2[_DYN_SANITIZE_PROPERTIES] = dataSanitizeProperties, _a2[_DYN_SANITIZE_MEASUREMENT3] = dataSanitizeMeasurements, _a2.sanitizeId = dataSanitizeId, _a2.sanitizeInput = dataSanitizeInput, _a2.padNumber = dsPadNumber, _a2.trim = strTrim, _a2);

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/UrlHelperFuncs.js
var _document = getDocument() || {};
var _htmlAnchorIdx = 0;
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
  var anchorIdx = _htmlAnchorIdx;
  var anchorCache = _htmlAnchorElement;
  var tempAnchor = anchorCache[anchorIdx];
  if (!_document.createElement) {
    tempAnchor = { host: urlParseHost(url, true) };
  } else if (!anchorCache[anchorIdx]) {
    tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
  }
  tempAnchor.href = url;
  anchorIdx++;
  if (anchorIdx >= anchorCache[_DYN_LENGTH2]) {
    anchorIdx = 0;
  }
  _htmlAnchorIdx = anchorIdx;
  return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
  var result;
  var a = urlParseUrl(url);
  if (a) {
    result = a.href;
  }
  return result;
}
function urlGetPathName(url) {
  var result;
  var a = urlParseUrl(url);
  if (a) {
    result = a[_DYN_PATHNAME];
  }
  return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
  if (method) {
    return method.toUpperCase() + " " + absoluteUrl;
  }
  return absoluteUrl;
}
function urlParseHost(url, inclPort) {
  var fullHost = urlParseFullHost(url, inclPort) || "";
  if (fullHost) {
    var match = fullHost.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i);
    if (match != null && match[_DYN_LENGTH2] > 3 && isString(match[2]) && match[2][_DYN_LENGTH2] > 0) {
      return match[2] + (match[3] || "");
    }
  }
  return fullHost;
}
function urlParseFullHost(url, inclPort) {
  var result = null;
  if (url) {
    var match = url.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i);
    if (match != null && match[_DYN_LENGTH2] > 2 && isString(match[2]) && match[2][_DYN_LENGTH2] > 0) {
      result = match[2] || "";
      if (inclPort && match[_DYN_LENGTH2] > 2) {
        var protocol = (match[1] || "")[_DYN_TO_LOWER_CASE2]();
        var port = match[3] || "";
        if (protocol === "http" && port === ":80") {
          port = "";
        } else if (protocol === "https" && port === ":443") {
          port = "";
        }
        result += port;
      }
    }
  }
  return result;
}

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Util.js
var _internalEndpoints = [
  DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH,
  "https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH,
  "https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH
];
function isInternalApplicationInsightsEndpoint(endpointUrl) {
  return arrIndexOf(_internalEndpoints, endpointUrl[_DYN_TO_LOWER_CASE2]()) !== -1;
}
var Util = {
  NotSpecified: strNotSpecified,
  createDomEvent,
  disableStorage: utlDisableStorage,
  isInternalApplicationInsightsEndpoint,
  canUseLocalStorage: utlCanUseLocalStorage,
  getStorage: utlGetLocalStorage,
  setStorage: utlSetLocalStorage,
  removeStorage: utlRemoveStorage,
  canUseSessionStorage: utlCanUseSessionStorage,
  getSessionStorageKeys: utlGetSessionStorageKeys,
  getSessionStorage: utlGetSessionStorage,
  setSessionStorage: utlSetSessionStorage,
  removeSessionStorage: utlRemoveSessionStorage,
  disableCookies,
  canUseCookies,
  disallowsSameSiteNone: uaDisallowsSameSiteNone,
  setCookie,
  stringToBoolOrDefault,
  getCookie,
  deleteCookie,
  trim: strTrim,
  newId,
  random32: function() {
    return random32(true);
  },
  generateW3CId,
  isArray,
  isError,
  isDate,
  toISOStringForIE8: toISOString,
  getIEVersion,
  msToTimeSpan,
  isCrossOriginError,
  dump: dumpObj,
  getExceptionName,
  addEventHandler: attachEvent,
  IsBeaconApiSupported: isBeaconsSupported,
  getExtension: getExtensionByName
};
var UrlHelper = {
  parseUrl: urlParseUrl,
  getAbsoluteUrl: urlGetAbsoluteUrl,
  getPathName: urlGetPathName,
  getCompleteUrl: urlGetCompleteUrl,
  parseHost: urlParseHost,
  parseFullHost: urlParseFullHost
};
var CorrelationIdHelper = {
  correlationIdPrefix: "cid-v1:",
  canIncludeCorrelationHeader: function(config, requestUrl, currentHost) {
    if (!requestUrl || config && config.disableCorrelationHeaders) {
      return false;
    }
    if (config && config[_DYN_CORRELATION_HEADER_E0]) {
      for (var i = 0; i < config.correlationHeaderExcludePatterns[_DYN_LENGTH2]; i++) {
        if (config[_DYN_CORRELATION_HEADER_E0][i].test(requestUrl)) {
          return false;
        }
      }
    }
    var requestHost = urlParseUrl(requestUrl).host[_DYN_TO_LOWER_CASE2]();
    if (requestHost && (requestHost[_DYN_INDEX_OF2](":443") !== -1 || requestHost[_DYN_INDEX_OF2](":80") !== -1)) {
      requestHost = (urlParseFullHost(requestUrl, true) || "")[_DYN_TO_LOWER_CASE2]();
    }
    if ((!config || !config.enableCorsCorrelation) && (requestHost && requestHost !== currentHost)) {
      return false;
    }
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
      var matchExists_1;
      arrForEach(includedDomains, function(domain) {
        var regex2 = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        matchExists_1 = matchExists_1 || regex2.test(requestHost);
      });
      if (!matchExists_1) {
        return false;
      }
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[_DYN_LENGTH2] === 0) {
      return true;
    }
    for (var i = 0; i < excludedDomains[_DYN_LENGTH2]; i++) {
      var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
      if (regex.test(requestHost)) {
        return false;
      }
    }
    return requestHost && requestHost[_DYN_LENGTH2] > 0;
  },
  getCorrelationContext: function(responseHeader) {
    if (responseHeader) {
      var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, RequestHeaders[1]);
      if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
        return correlationId;
      }
    }
  },
  getCorrelationContextValue: function(responseHeader, key) {
    if (responseHeader) {
      var keyValues = responseHeader[_DYN_SPLIT2](",");
      for (var i = 0; i < keyValues[_DYN_LENGTH2]; ++i) {
        var keyValue = keyValues[i][_DYN_SPLIT2]("=");
        if (keyValue[_DYN_LENGTH2] === 2 && keyValue[0] === key) {
          return keyValue[1];
        }
      }
    }
  }
};
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
  var target, name = commandName, data = commandName;
  if (absoluteUrl && absoluteUrl[_DYN_LENGTH2] > 0) {
    var parsedUrl = urlParseUrl(absoluteUrl);
    target = parsedUrl.host;
    if (!name) {
      if (parsedUrl[_DYN_PATHNAME] != null) {
        var pathName = parsedUrl.pathname[_DYN_LENGTH2] === 0 ? "/" : parsedUrl[_DYN_PATHNAME];
        if (pathName.charAt(0) !== "/") {
          pathName = "/" + pathName;
        }
        data = parsedUrl[_DYN_PATHNAME];
        name = dataSanitizeString(logger, method ? method + " " + pathName : pathName);
      } else {
        name = dataSanitizeString(logger, absoluteUrl);
      }
    }
  } else {
    target = commandName;
    name = commandName;
  }
  return {
    target,
    name,
    data
  };
}
function dateTimeUtilsNow() {
  var perf = getPerformance();
  if (perf && perf.now && perf.timing) {
    var now = perf.now() + perf.timing.navigationStart;
    if (now > 0) {
      return now;
    }
  }
  return dateNow();
}
function dateTimeUtilsDuration(start, end) {
  var result = null;
  if (start !== 0 && end !== 0 && !isNullOrUndefined(start) && !isNullOrUndefined(end)) {
    result = end - start;
  }
  return result;
}
var DateTimeUtils = {
  Now: dateTimeUtilsNow,
  GetDuration: dateTimeUtilsDuration
};
function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
  var trace = telemetryTrace || {};
  return {
    getName: function() {
      return trace[_DYN_NAME2];
    },
    setName: function(newValue) {
      parentCtx && parentCtx.setName(newValue);
      trace[_DYN_NAME2] = newValue;
    },
    getTraceId: function() {
      return trace.traceID;
    },
    setTraceId: function(newValue) {
      parentCtx && parentCtx.setTraceId(newValue);
      if (isValidTraceId(newValue)) {
        trace.traceID = newValue;
      }
    },
    getSpanId: function() {
      return trace.parentID;
    },
    setSpanId: function(newValue) {
      parentCtx && parentCtx.setSpanId(newValue);
      if (isValidSpanId(newValue)) {
        trace.parentID = newValue;
      }
    },
    getTraceFlags: function() {
      return trace.traceFlags;
    },
    setTraceFlags: function(newTraceFlags) {
      parentCtx && parentCtx.setTraceFlags(newTraceFlags);
      trace.traceFlags = newTraceFlags;
    }
  };
}

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Event.js
var Event2 = function() {
  function Event3(logger, name, properties, measurements) {
    this.aiDataContract = {
      ver: 1,
      name: 1,
      properties: 0,
      measurements: 0
    };
    var _self = this;
    _self.ver = 2;
    _self[_DYN_NAME2] = dataSanitizeString(logger, name) || strNotSpecified;
    _self[_DYN_PROPERTIES] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS] = dataSanitizeMeasurements(logger, measurements);
  }
  Event3.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
  Event3.dataType = "EventData";
  return Event3;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Exception.js
var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
  var result = value;
  if (result && !isString(result)) {
    if (JSON && JSON[_DYN_STRINGIFY]) {
      result = JSON[_DYN_STRINGIFY](value);
      if (convertToString && (!result || result === "{}")) {
        if (isFunction(value[_DYN_TO_STRING])) {
          result = value[_DYN_TO_STRING]();
        } else {
          result = "" + value;
        }
      }
    } else {
      result = "" + value + " - (Missing JSON.stringify)";
    }
  }
  return result || "";
}
function _formatMessage(theEvent, errorType) {
  var evtMessage = theEvent;
  if (theEvent) {
    if (evtMessage && !isString(evtMessage)) {
      evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
    }
    if (evtMessage && !isString(evtMessage)) {
      evtMessage = _stringify(evtMessage, true);
    }
    if (theEvent["filename"]) {
      evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
    }
  }
  if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "")[_DYN_INDEX_OF2](errorType) === -1) {
    evtMessage = errorType + ": " + evtMessage;
  }
  return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
  try {
    if (isObject(value)) {
      return "hasFullStack" in value && "typeName" in value;
    }
  } catch (e) {
  }
  return false;
}
function _isExceptionInternal(value) {
  try {
    if (isObject(value)) {
      return "ver" in value && "exceptions" in value && "properties" in value;
    }
  } catch (e) {
  }
  return false;
}
function _isStackDetails(details) {
  return details && details.src && isString(details.src) && details.obj && isArray(details.obj);
}
function _convertStackObj(errorStack) {
  var src = errorStack || "";
  if (!isString(src)) {
    if (isString(src[strStack])) {
      src = src[strStack];
    } else {
      src = "" + src;
    }
  }
  var items = src[_DYN_SPLIT2]("\n");
  return {
    src,
    obj: items
  };
}
function _getOperaStack(errorMessage) {
  var stack = [];
  var lines = errorMessage[_DYN_SPLIT2]("\n");
  for (var lp = 0; lp < lines[_DYN_LENGTH2]; lp++) {
    var entry = lines[lp];
    if (lines[lp + 1]) {
      entry += "@" + lines[lp + 1];
      lp++;
    }
    stack.push(entry);
  }
  return {
    src: errorMessage,
    obj: stack
  };
}
function _getStackFromErrorObj(errorObj) {
  var details = null;
  if (errorObj) {
    try {
      if (errorObj[strStack]) {
        details = _convertStackObj(errorObj[strStack]);
      } else if (errorObj[strError] && errorObj[strError][strStack]) {
        details = _convertStackObj(errorObj[strError][strStack]);
      } else if (errorObj["exception"] && errorObj.exception[strStack]) {
        details = _convertStackObj(errorObj.exception[strStack]);
      } else if (_isStackDetails(errorObj)) {
        details = errorObj;
      } else if (_isStackDetails(errorObj[strStackDetails])) {
        details = errorObj[strStackDetails];
      } else if (window && window["opera"] && errorObj[strMessage]) {
        details = _getOperaStack(errorObj[_DYN_MESSAGE2]);
      } else if (errorObj["reason"] && errorObj.reason[strStack]) {
        details = _convertStackObj(errorObj.reason[strStack]);
      } else if (isString(errorObj)) {
        details = _convertStackObj(errorObj);
      } else {
        var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
        if (isString(errorObj[strErrorSrc])) {
          if (evtMessage) {
            evtMessage += "\n";
          }
          evtMessage += " from " + errorObj[strErrorSrc];
        }
        if (evtMessage) {
          details = _convertStackObj(evtMessage);
        }
      }
    } catch (e) {
      details = _convertStackObj(e);
    }
  }
  return details || {
    src: "",
    obj: null
  };
}
function _formatStackTrace(stackDetails) {
  var stack = "";
  if (stackDetails) {
    if (stackDetails.obj) {
      arrForEach(stackDetails.obj, function(entry) {
        stack += entry + "\n";
      });
    } else {
      stack = stackDetails.src || "";
    }
  }
  return stack;
}
function _parseStack(stack) {
  var parsedStack;
  var frames = stack.obj;
  if (frames && frames[_DYN_LENGTH2] > 0) {
    parsedStack = [];
    var level_1 = 0;
    var totalSizeInBytes_1 = 0;
    arrForEach(frames, function(frame) {
      var theFrame = frame[_DYN_TO_STRING]();
      if (_StackFrame.regex.test(theFrame)) {
        var parsedFrame = new _StackFrame(theFrame, level_1++);
        totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES];
        parsedStack.push(parsedFrame);
      }
    });
    var exceptionParsedStackThreshold = 32 * 1024;
    if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
      var left = 0;
      var right = parsedStack[_DYN_LENGTH2] - 1;
      var size = 0;
      var acceptedLeft = left;
      var acceptedRight = right;
      while (left < right) {
        var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES];
        var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES];
        size += lSize + rSize;
        if (size > exceptionParsedStackThreshold) {
          var howMany = acceptedRight - acceptedLeft + 1;
          parsedStack.splice(acceptedLeft, howMany);
          break;
        }
        acceptedLeft = left;
        acceptedRight = right;
        left++;
        right--;
      }
    }
  }
  return parsedStack;
}
function _getErrorType(errorType) {
  var typeName = "";
  if (errorType) {
    typeName = errorType.typeName || errorType[_DYN_NAME2] || "";
    if (!typeName) {
      try {
        var funcNameRegex = /function (.{1,200})\(/;
        var results = funcNameRegex.exec(errorType.constructor[_DYN_TO_STRING]());
        typeName = results && results[_DYN_LENGTH2] > 1 ? results[1] : "";
      } catch (e) {
      }
    }
  }
  return typeName;
}
function _formatErrorCode(errorObj) {
  if (errorObj) {
    try {
      if (!isString(errorObj)) {
        var errorType = _getErrorType(errorObj);
        var result = _stringify(errorObj, false);
        if (!result || result === "{}") {
          if (errorObj[strError]) {
            errorObj = errorObj[strError];
            errorType = _getErrorType(errorObj);
          }
          result = _stringify(errorObj, true);
        }
        if (result[_DYN_INDEX_OF2](errorType) !== 0 && errorType !== "String") {
          return errorType + ":" + result;
        }
        return result;
      }
    } catch (e) {
    }
  }
  return "" + (errorObj || "");
}
var Exception = function() {
  function Exception2(logger, exception, properties, measurements, severityLevel, id) {
    this.aiDataContract = {
      ver: 1,
      exceptions: 1,
      severityLevel: 0,
      properties: 0,
      measurements: 0
    };
    var _self = this;
    _self.ver = 2;
    if (!_isExceptionInternal(exception)) {
      if (!properties) {
        properties = {};
      }
      _self[_DYN_EXCEPTIONS] = [new _ExceptionDetails(logger, exception, properties)];
      _self[_DYN_PROPERTIES] = dataSanitizeProperties(logger, properties);
      _self[_DYN_MEASUREMENTS] = dataSanitizeMeasurements(logger, measurements);
      if (severityLevel) {
        _self[_DYN_SEVERITY_LEVEL] = severityLevel;
      }
      if (id) {
        _self.id = id;
      }
    } else {
      _self[_DYN_EXCEPTIONS] = exception[_DYN_EXCEPTIONS] || [];
      _self[_DYN_PROPERTIES] = exception[_DYN_PROPERTIES];
      _self[_DYN_MEASUREMENTS] = exception[_DYN_MEASUREMENTS];
      if (exception[_DYN_SEVERITY_LEVEL]) {
        _self[_DYN_SEVERITY_LEVEL] = exception[_DYN_SEVERITY_LEVEL];
      }
      if (exception.id) {
        _self.id = exception.id;
      }
      if (exception[_DYN_PROBLEM_GROUP]) {
        _self[_DYN_PROBLEM_GROUP] = exception[_DYN_PROBLEM_GROUP];
      }
      if (!isNullOrUndefined(exception[_DYN_IS_MANUAL])) {
        _self[_DYN_IS_MANUAL] = exception[_DYN_IS_MANUAL];
      }
    }
  }
  Exception2.CreateAutoException = function(message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
    var _a3;
    var errorType = _getErrorType(error || evt || message);
    return _a3 = {}, _a3[_DYN_MESSAGE2] = _formatMessage(message, errorType), _a3.url = url, _a3.lineNumber = lineNumber, _a3.columnNumber = columnNumber, _a3.error = _formatErrorCode(error || evt || message), _a3.evt = _formatErrorCode(evt || message), _a3[_DYN_TYPE_NAME] = errorType, _a3.stackDetails = _getStackFromErrorObj(stack || error || evt), _a3.errorSrc = errorSrc, _a3;
  };
  Exception2.CreateFromInterface = function(logger, exception, properties, measurements) {
    var exceptions = exception[_DYN_EXCEPTIONS] && arrMap(exception[_DYN_EXCEPTIONS], function(ex) {
      return _ExceptionDetails[_DYN__CREATE_FROM_INTERFA1](logger, ex);
    });
    var exceptionData = new Exception2(logger, __assignFn(__assignFn({}, exception), { exceptions }), properties, measurements);
    return exceptionData;
  };
  Exception2.prototype.toInterface = function() {
    var _a3;
    var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
    var exceptionDetailsInterface = exceptions instanceof Array && arrMap(exceptions, function(exception) {
      return exception.toInterface();
    }) || void 0;
    return _a3 = {
      ver: "4.0"
    }, _a3[_DYN_EXCEPTIONS] = exceptionDetailsInterface, _a3.severityLevel = severityLevel, _a3.properties = properties, _a3.measurements = measurements, _a3.problemGroup = problemGroup, _a3.id = id, _a3.isManual = isManual, _a3;
  };
  Exception2.CreateSimpleException = function(message, typeName, assembly, fileName, details, line) {
    var _a3;
    return {
      exceptions: [
        (_a3 = {}, _a3[_DYN_HAS_FULL_STACK] = true, _a3.message = message, _a3.stack = details, _a3.typeName = typeName, _a3)
      ]
    };
  };
  Exception2.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
  Exception2.dataType = "ExceptionData";
  Exception2.formatError = _formatErrorCode;
  return Exception2;
}();
var _ExceptionDetails = function() {
  function _ExceptionDetails2(logger, exception, properties) {
    this.aiDataContract = {
      id: 0,
      outerId: 0,
      typeName: 1,
      message: 1,
      hasFullStack: 0,
      stack: 0,
      parsedStack: 2
    };
    var _self = this;
    if (!_isExceptionDetailsInternal(exception)) {
      var error = exception;
      var evt = error && error.evt;
      if (!isError(error)) {
        error = error[strError] || evt || error;
      }
      _self[_DYN_TYPE_NAME] = dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
      _self[_DYN_MESSAGE2] = dataSanitizeMessage(logger, _formatMessage(exception || error, _self[_DYN_TYPE_NAME])) || strNotSpecified;
      var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
      _self[_DYN_PARSED_STACK] = _parseStack(stack);
      _self[strStack] = dataSanitizeException(logger, _formatStackTrace(stack));
      _self.hasFullStack = isArray(_self.parsedStack) && _self.parsedStack[_DYN_LENGTH2] > 0;
      if (properties) {
        properties[_DYN_TYPE_NAME] = properties[_DYN_TYPE_NAME] || _self[_DYN_TYPE_NAME];
      }
    } else {
      _self[_DYN_TYPE_NAME] = exception[_DYN_TYPE_NAME];
      _self[_DYN_MESSAGE2] = exception[_DYN_MESSAGE2];
      _self[strStack] = exception[strStack];
      _self[_DYN_PARSED_STACK] = exception[_DYN_PARSED_STACK] || [];
      _self[_DYN_HAS_FULL_STACK] = exception[_DYN_HAS_FULL_STACK];
    }
  }
  _ExceptionDetails2.prototype.toInterface = function() {
    var _a3;
    var _self = this;
    var parsedStack = _self[_DYN_PARSED_STACK] instanceof Array && arrMap(_self[_DYN_PARSED_STACK], function(frame) {
      return frame.toInterface();
    });
    var exceptionDetailsInterface = (_a3 = {
      id: _self.id,
      outerId: _self.outerId,
      typeName: _self[_DYN_TYPE_NAME],
      message: _self[_DYN_MESSAGE2],
      hasFullStack: _self[_DYN_HAS_FULL_STACK],
      stack: _self[strStack]
    }, _a3[_DYN_PARSED_STACK] = parsedStack || void 0, _a3);
    return exceptionDetailsInterface;
  };
  _ExceptionDetails2.CreateFromInterface = function(logger, exception) {
    var parsedStack = exception[_DYN_PARSED_STACK] instanceof Array && arrMap(exception[_DYN_PARSED_STACK], function(frame) {
      return _StackFrame[_DYN__CREATE_FROM_INTERFA1](frame);
    }) || exception[_DYN_PARSED_STACK];
    var exceptionDetails = new _ExceptionDetails2(logger, __assignFn(__assignFn({}, exception), { parsedStack }));
    return exceptionDetails;
  };
  return _ExceptionDetails2;
}();
var _StackFrame = function() {
  function _StackFrame2(sourceFrame, level) {
    this.aiDataContract = {
      level: 1,
      method: 1,
      assembly: 0,
      fileName: 0,
      line: 0
    };
    var _self = this;
    _self[_DYN_SIZE_IN_BYTES] = 0;
    if (typeof sourceFrame === "string") {
      var frame = sourceFrame;
      _self[_DYN_LEVEL] = level;
      _self[_DYN_METHOD] = NoMethod;
      _self[_DYN_ASSEMBLY] = strTrim(frame);
      _self[_DYN_FILE_NAME] = "";
      _self[_DYN_LINE] = 0;
      var matches = frame.match(_StackFrame2.regex);
      if (matches && matches[_DYN_LENGTH2] >= 5) {
        _self[_DYN_METHOD] = strTrim(matches[2]) || _self[_DYN_METHOD];
        _self[_DYN_FILE_NAME] = strTrim(matches[4]);
        _self[_DYN_LINE] = parseInt(matches[5]) || 0;
      }
    } else {
      _self[_DYN_LEVEL] = sourceFrame[_DYN_LEVEL];
      _self[_DYN_METHOD] = sourceFrame[_DYN_METHOD];
      _self[_DYN_ASSEMBLY] = sourceFrame[_DYN_ASSEMBLY];
      _self[_DYN_FILE_NAME] = sourceFrame[_DYN_FILE_NAME];
      _self[_DYN_LINE] = sourceFrame[_DYN_LINE];
      _self[_DYN_SIZE_IN_BYTES] = 0;
    }
    _self.sizeInBytes += _self.method[_DYN_LENGTH2];
    _self.sizeInBytes += _self.fileName[_DYN_LENGTH2];
    _self.sizeInBytes += _self.assembly[_DYN_LENGTH2];
    _self[_DYN_SIZE_IN_BYTES] += _StackFrame2.baseSize;
    _self.sizeInBytes += _self.level.toString()[_DYN_LENGTH2];
    _self.sizeInBytes += _self.line.toString()[_DYN_LENGTH2];
  }
  _StackFrame2.CreateFromInterface = function(frame) {
    return new _StackFrame2(frame, null);
  };
  _StackFrame2.prototype.toInterface = function() {
    var _self = this;
    return {
      level: _self[_DYN_LEVEL],
      method: _self[_DYN_METHOD],
      assembly: _self[_DYN_ASSEMBLY],
      fileName: _self[_DYN_FILE_NAME],
      line: _self[_DYN_LINE]
    };
  };
  _StackFrame2.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
  _StackFrame2.baseSize = 58;
  return _StackFrame2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/DataPoint.js
var DataPoint = function() {
  function DataPoint2() {
    this.aiDataContract = {
      name: 1,
      kind: 0,
      value: 1,
      count: 0,
      min: 0,
      max: 0,
      stdDev: 0
    };
    this.kind = 0;
  }
  return DataPoint2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Metric.js
var Metric = function() {
  function Metric2(logger, name, value, count, min, max, stdDev, properties, measurements) {
    this.aiDataContract = {
      ver: 1,
      metrics: 1,
      properties: 0
    };
    var _self = this;
    _self.ver = 2;
    var dataPoint = new DataPoint();
    dataPoint.count = count > 0 ? count : void 0;
    dataPoint.max = isNaN(max) || max === null ? void 0 : max;
    dataPoint.min = isNaN(min) || min === null ? void 0 : min;
    dataPoint[_DYN_NAME2] = dataSanitizeString(logger, name) || strNotSpecified;
    dataPoint.value = value;
    dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? void 0 : stdDev;
    _self.metrics = [dataPoint];
    _self[_DYN_PROPERTIES] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS] = dataSanitizeMeasurements(logger, measurements);
  }
  Metric2.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
  Metric2.dataType = "MetricData";
  return Metric2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/PageView.js
var PageView = function() {
  function PageView2(logger, name, url, durationMs, properties, measurements, id) {
    this.aiDataContract = {
      ver: 1,
      name: 0,
      url: 0,
      duration: 0,
      properties: 0,
      measurements: 0,
      id: 0
    };
    var _self = this;
    _self.ver = 2;
    _self.id = dataSanitizeId(logger, id);
    _self.url = dataSanitizeUrl(logger, url);
    _self[_DYN_NAME2] = dataSanitizeString(logger, name) || strNotSpecified;
    if (!isNaN(durationMs)) {
      _self[_DYN_DURATION] = msToTimeSpan(durationMs);
    }
    _self[_DYN_PROPERTIES] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS] = dataSanitizeMeasurements(logger, measurements);
  }
  PageView2.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
  PageView2.dataType = "PageviewData";
  return PageView2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/RemoteDependencyData.js
var RemoteDependencyData = function() {
  function RemoteDependencyData2(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
    if (requestAPI === void 0) {
      requestAPI = "Ajax";
    }
    this.aiDataContract = {
      id: 1,
      ver: 1,
      name: 0,
      resultCode: 0,
      duration: 0,
      success: 0,
      data: 0,
      target: 0,
      type: 0,
      properties: 0,
      measurements: 0,
      kind: 0,
      value: 0,
      count: 0,
      min: 0,
      max: 0,
      stdDev: 0,
      dependencyKind: 0,
      dependencySource: 0,
      commandName: 0,
      dependencyTypeName: 0
    };
    var _self = this;
    _self.ver = 2;
    _self.id = id;
    _self[_DYN_DURATION] = msToTimeSpan(value);
    _self.success = success;
    _self.resultCode = resultCode + "";
    _self.type = dataSanitizeString(logger, requestAPI);
    var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
    _self.data = dataSanitizeUrl(logger, commandName) || dependencyFields.data;
    _self.target = dataSanitizeString(logger, dependencyFields.target);
    if (correlationContext) {
      _self.target = "".concat(_self.target, " | ").concat(correlationContext);
    }
    _self[_DYN_NAME2] = dataSanitizeString(logger, dependencyFields[_DYN_NAME2]);
    _self[_DYN_PROPERTIES] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS] = dataSanitizeMeasurements(logger, measurements);
  }
  RemoteDependencyData2.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
  RemoteDependencyData2.dataType = "RemoteDependencyData";
  return RemoteDependencyData2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Trace.js
var Trace = function() {
  function Trace2(logger, message, severityLevel, properties, measurements) {
    this.aiDataContract = {
      ver: 1,
      message: 1,
      severityLevel: 0,
      properties: 0
    };
    var _self = this;
    _self.ver = 2;
    message = message || strNotSpecified;
    _self[_DYN_MESSAGE2] = dataSanitizeMessage(logger, message);
    _self[_DYN_PROPERTIES] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS] = dataSanitizeMeasurements(logger, measurements);
    if (severityLevel) {
      _self[_DYN_SEVERITY_LEVEL] = severityLevel;
    }
  }
  Trace2.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
  Trace2.dataType = "MessageData";
  return Trace2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/PageViewPerformance.js
var PageViewPerformance = function() {
  function PageViewPerformance2(logger, name, url, unused, properties, measurements, cs4BaseData) {
    this.aiDataContract = {
      ver: 1,
      name: 0,
      url: 0,
      duration: 0,
      perfTotal: 0,
      networkConnect: 0,
      sentRequest: 0,
      receivedResponse: 0,
      domProcessing: 0,
      properties: 0,
      measurements: 0
    };
    var _self = this;
    _self.ver = 2;
    _self.url = dataSanitizeUrl(logger, url);
    _self[_DYN_NAME2] = dataSanitizeString(logger, name) || strNotSpecified;
    _self[_DYN_PROPERTIES] = dataSanitizeProperties(logger, properties);
    _self[_DYN_MEASUREMENTS] = dataSanitizeMeasurements(logger, measurements);
    if (cs4BaseData) {
      _self.domProcessing = cs4BaseData.domProcessing;
      _self[_DYN_DURATION] = cs4BaseData[_DYN_DURATION];
      _self.networkConnect = cs4BaseData.networkConnect;
      _self.perfTotal = cs4BaseData.perfTotal;
      _self[_DYN_RECEIVED_RESPONSE] = cs4BaseData[_DYN_RECEIVED_RESPONSE];
      _self.sentRequest = cs4BaseData.sentRequest;
    }
  }
  PageViewPerformance2.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
  PageViewPerformance2.dataType = "PageviewPerformanceData";
  return PageViewPerformance2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Interfaces/Contracts/SeverityLevel.js
var SeverityLevel = createEnumStyle({
  Verbose: 0,
  Information: 1,
  Warning: 2,
  Error: 3,
  Critical: 4
});

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/ConnectionStringParser.js
var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
  if (!connectionString) {
    return {};
  }
  var kvPairs = connectionString[_DYN_SPLIT2](_FIELDS_SEPARATOR);
  var result = arrReduce(kvPairs, function(fields, kv) {
    var kvParts = kv[_DYN_SPLIT2](_FIELD_KEY_VALUE_SEPARATOR);
    if (kvParts[_DYN_LENGTH2] === 2) {
      var key = kvParts[0][_DYN_TO_LOWER_CASE2]();
      var value = kvParts[1];
      fields[key] = value;
    }
    return fields;
  }, {});
  if (objKeys(result)[_DYN_LENGTH2] > 0) {
    if (result.endpointsuffix) {
      var locationPrefix = result.location ? result.location + "." : "";
      result[_DYN_INGESTIONENDPOINT] = result[_DYN_INGESTIONENDPOINT] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
    }
    result[_DYN_INGESTIONENDPOINT] = result[_DYN_INGESTIONENDPOINT] || DEFAULT_BREEZE_ENDPOINT;
  }
  return result;
}
var ConnectionStringParser = {
  parse: parseConnectionString
};

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/Envelope.js
var Envelope = function() {
  function Envelope2(logger, data, name) {
    var _this = this;
    var _self = this;
    _self.ver = 1;
    _self.sampleRate = 100;
    _self.tags = {};
    _self[_DYN_NAME2] = dataSanitizeString(logger, name) || strNotSpecified;
    _self.data = data;
    _self.time = toISOString(new Date());
    _self.aiDataContract = {
      time: 1,
      iKey: 1,
      name: 1,
      sampleRate: function() {
        return _this.sampleRate === 100 ? 4 : 1;
      },
      tags: 1,
      data: 1
    };
  }
  return Envelope2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/Data.js
var Data = function() {
  function Data2(baseType, data) {
    this.aiDataContract = {
      baseType: 1,
      baseData: 1
    };
    this.baseType = baseType;
    this.baseData = data;
  }
  return Data2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Interfaces/IConfig.js
var ConfigurationManager = function() {
  function ConfigurationManager2() {
  }
  ConfigurationManager2.getConfig = function(config, field, identifier, defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = false;
    }
    var configValue;
    if (identifier && config[_DYN_EXTENSION_CONFIG] && config[_DYN_EXTENSION_CONFIG][identifier] && !isNullOrUndefined(config[_DYN_EXTENSION_CONFIG][identifier][field])) {
      configValue = config[_DYN_EXTENSION_CONFIG][identifier][field];
    } else {
      configValue = config[field];
    }
    return !isNullOrUndefined(configValue) ? configValue : defaultValue;
  };
  return ConfigurationManager2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Interfaces/Contracts/ContextTagKeys.js
function _aiNameFunc(baseName) {
  var aiName = "ai." + baseName + ".";
  return function(name) {
    return aiName + name;
  };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = function(_super) {
  __extendsFn(ContextTagKeys2, _super);
  function ContextTagKeys2() {
    return _super.call(this) || this;
  }
  return ContextTagKeys2;
}(createClassFromInterface({
  applicationVersion: _aiApplication("ver"),
  applicationBuild: _aiApplication("build"),
  applicationTypeId: _aiApplication("typeId"),
  applicationId: _aiApplication("applicationId"),
  applicationLayer: _aiApplication("layer"),
  deviceId: _aiDevice("id"),
  deviceIp: _aiDevice("ip"),
  deviceLanguage: _aiDevice("language"),
  deviceLocale: _aiDevice("locale"),
  deviceModel: _aiDevice("model"),
  deviceFriendlyName: _aiDevice("friendlyName"),
  deviceNetwork: _aiDevice("network"),
  deviceNetworkName: _aiDevice("networkName"),
  deviceOEMName: _aiDevice("oemName"),
  deviceOS: _aiDevice("os"),
  deviceOSVersion: _aiDevice("osVersion"),
  deviceRoleInstance: _aiDevice("roleInstance"),
  deviceRoleName: _aiDevice("roleName"),
  deviceScreenResolution: _aiDevice("screenResolution"),
  deviceType: _aiDevice("type"),
  deviceMachineName: _aiDevice("machineName"),
  deviceVMName: _aiDevice("vmName"),
  deviceBrowser: _aiDevice("browser"),
  deviceBrowserVersion: _aiDevice("browserVersion"),
  locationIp: _aiLocation("ip"),
  locationCountry: _aiLocation("country"),
  locationProvince: _aiLocation("province"),
  locationCity: _aiLocation("city"),
  operationId: _aiOperation("id"),
  operationName: _aiOperation("name"),
  operationParentId: _aiOperation("parentId"),
  operationRootId: _aiOperation("rootId"),
  operationSyntheticSource: _aiOperation("syntheticSource"),
  operationCorrelationVector: _aiOperation("correlationVector"),
  sessionId: _aiSession("id"),
  sessionIsFirst: _aiSession("isFirst"),
  sessionIsNew: _aiSession("isNew"),
  userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
  userAccountId: _aiUser("accountId"),
  userAgent: _aiUser("userAgent"),
  userId: _aiUser("id"),
  userStoreRegion: _aiUser("storeRegion"),
  userAuthUserId: _aiUser("authUserId"),
  userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
  userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
  cloudName: _aiCloud("name"),
  cloudRole: _aiCloud("role"),
  cloudRoleVer: _aiCloud("roleVer"),
  cloudRoleInstance: _aiCloud("roleInstance"),
  cloudEnvironment: _aiCloud("environment"),
  cloudLocation: _aiCloud("location"),
  cloudDeploymentUnit: _aiCloud("deploymentUnit"),
  internalNodeName: _aiInternal("nodeName"),
  internalSdkVersion: _aiInternal("sdkVersion"),
  internalAgentVersion: _aiInternal("agentVersion"),
  internalSnippet: _aiInternal("snippet"),
  internalSdkSrc: _aiInternal("sdkSrc")
}));

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/TelemetryItemCreator.js
function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
  var _a3;
  envelopeName = dataSanitizeString(logger, envelopeName) || strNotSpecified;
  if (isNullOrUndefined(item) || isNullOrUndefined(baseType) || isNullOrUndefined(envelopeName)) {
    throwError("Input doesn't contain all required fields");
  }
  var iKey = "";
  if (item[strIkey]) {
    iKey = item[strIkey];
    delete item[strIkey];
  }
  var telemetryItem = (_a3 = {}, _a3[_DYN_NAME2] = envelopeName, _a3.time = toISOString(new Date()), _a3.iKey = iKey, _a3.ext = systemProperties ? systemProperties : {}, _a3.tags = [], _a3.data = {}, _a3.baseType = baseType, _a3.baseData = item, _a3);
  if (!isNullOrUndefined(customProperties)) {
    objForEachKey(customProperties, function(prop, value) {
      telemetryItem.data[prop] = value;
    });
  }
  return telemetryItem;
}
var TelemetryItemCreator = function() {
  function TelemetryItemCreator2() {
  }
  TelemetryItemCreator2.create = createTelemetryItem;
  return TelemetryItemCreator2;
}();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/Interfaces/PartAExtensions.js
var Extensions = {
  UserExt: "user",
  DeviceExt: "device",
  TraceExt: "trace",
  WebExt: "web",
  AppExt: "app",
  OSExt: "os",
  SessionExt: "ses",
  SDKExt: "sdk"
};
var CtxTagKeys = new ContextTagKeys();

// node_modules/.pnpm/@microsoft+applicationinsights-common@2.8.8/node_modules/@microsoft/applicationinsights-common/dist-esm/applicationinsights-common.js
var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";

export {
  strShimUndefined,
  strShimPrototype,
  getGlobal,
  __assignFn,
  __extendsFn,
  dynamicProto,
  isUndefined,
  isNullOrUndefined,
  isObject,
  isFunction,
  normalizeJsName,
  objForEachKey,
  isArray,
  isString,
  isNumber,
  toISOString,
  arrForEach,
  arrIndexOf,
  strTrim,
  objKeys,
  objDefineAccessors,
  deepFreeze,
  dateNow,
  getExceptionName,
  setValue,
  getSetValue,
  isTruthy,
  throwError,
  proxyAssign,
  proxyFunctions,
  optimizeObject,
  hasWindow,
  getWindow,
  hasDocument,
  getDocument,
  getNavigator,
  hasHistory,
  getHistory,
  getLocation,
  getPerformance,
  hasJSON,
  getJSON,
  isReactNative,
  getIEVersion,
  dumpObj,
  isBeaconsSupported,
  isFetchSupported,
  useXDomainRequest,
  isXhrSupported,
  _InternalLogMessage,
  safeGetLogger,
  _throwInternal,
  _warnToConsole,
  _logInternalMessage,
  PerfEvent,
  PerfManager,
  doPerf,
  newId,
  createUniqueNamespace,
  safeGetCookieMgr,
  mergeEvtNamespace,
  eventOn,
  eventOff,
  addPageUnloadEventListener,
  removePageUnloadEventListener,
  addPageHideEventListener,
  removePageHideEventListener,
  generateW3CId,
  CoreUtils,
  _legacyCookieMgr,
  createTraceParent,
  formatTraceParent,
  createProcessTelemetryContext,
  BaseTelemetryPlugin,
  BaseCore,
  NotificationManager,
  AppInsightsCore,
  LoggingSeverity,
  _InternalMessageId,
  InstrumentProto,
  InstrumentFunc,
  InstrumentEvent,
  DisabledPropertyName,
  SampleRate,
  ProcessLegacy,
  HttpMethod,
  DEFAULT_BREEZE_ENDPOINT,
  DEFAULT_BREEZE_PATH,
  strNotSpecified,
  createDomEvent,
  stringToBoolOrDefault,
  msToTimeSpan,
  isCrossOriginError,
  RequestHeaders,
  DistributedTracingModes,
  utlDisableStorage,
  utlEnableStorage,
  utlCanUseLocalStorage,
  utlGetLocalStorage,
  utlSetLocalStorage,
  utlRemoveStorage,
  utlCanUseSessionStorage,
  utlGetSessionStorage,
  utlSetSessionStorage,
  utlRemoveSessionStorage,
  dataSanitizeString,
  dataSanitizeUrl,
  DataSanitizer,
  urlGetAbsoluteUrl,
  urlGetCompleteUrl,
  isInternalApplicationInsightsEndpoint,
  Util,
  UrlHelper,
  CorrelationIdHelper,
  dateTimeUtilsNow,
  dateTimeUtilsDuration,
  DateTimeUtils,
  createDistributedTraceContextFromTrace,
  parseConnectionString,
  ConnectionStringParser,
  Envelope,
  Event2 as Event,
  Exception,
  Metric,
  PageView,
  RemoteDependencyData,
  Trace,
  PageViewPerformance,
  Data,
  SeverityLevel,
  ConfigurationManager,
  ContextTagKeys,
  createTelemetryItem,
  TelemetryItemCreator,
  Extensions,
  CtxTagKeys,
  PropertiesPluginIdentifier,
  BreezeChannelIdentifier,
  AnalyticsPluginIdentifier
};
/*!
 * Microsoft Dynamic Proto Utility, 1.1.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
//# sourceMappingURL=chunk-QJXNZHKV.js.map
